import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe, formatDate } from '@angular/common';
import { DashboardService } from '../service/dashboard.service';
import { ClientService } from '../holl-client-management/client.service';
import { Client } from '../holl-client-management/client.model';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import swal, { SweetAlertResult } from 'sweetalert2';
import { MatStepper } from '@angular/material/stepper';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';
import { ShowPremiumTotalComponent } from '../dialogs/show-premium-total/show-premium-total.component';
import { SelectPaymentMethodComponent } from '../dialogs/select-payment-method/select-payment-method.component';
import { CashPaymentComponent } from '../dialogs/cash-payment/cash-payment.component';
import { ChequePaymentComponent } from '../dialogs/cheque-payment/cheque-payment.component';
import { CreateCustomerComponent } from '../dialogs/create-customer/create-customer.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DebitCardPaymentComponent } from '../dialogs/debit-card-payment/debit-card-payment.component';
import { FormControl } from '@angular/forms';
import { debounceTime, tap, switchMap, finalize } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { MomoPaymentComponent } from '../dialogs/momo-payment/momo-payment.component';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { uploadExcelDataDialogComponent } from '../dialogs/upload-excel-data/upload-excel-data.component';
import { QuoteSummaryComponent } from '../dialogs/quote-summary/quote-summary.component';
import { QuoteSummaryFleetComponent } from '../dialogs/quote-summary-fleet/quote-summary-fleet.component';
import { FinalizeRetryMomoComponent } from '../dialogs/finalize-retry-momo/finalize-retry-momo.component';



interface CustomerProfile {
  CLIENT_CODE: string;
  CLIENT_TYPE?: string;
  CLIENT_FAMILY_NAME: string;
  CLIENT_HOME_MOBILE: string;
  CLIENT_FIRST_NAME: string;
  CLIENT_HOME_EMAIL?: string;
  CLIENT_DATE_OF_BIRTH?: string;
  CLIENT_GHANA_CARD_NUMBER?: string;
  DISPLAY_NAME?: string;
  DISPLAY_SHORT_NAME?: string;
  isNewCustomer?: boolean;
}
interface CustomerResponse {
  responseCode: string;
  responseMessage: string;
  data: string;
  account_activation_requested: string;
  agent_pin_set: string;
  responseData: any;
  profile: CustomerProfile[];
}
interface Make {
  VEHICLE_MAKE_CODE: string;
  VEHICLE_MAKE_DESC: string;
  DISPLAY_SHORT_NAME: string;
}
interface MakeResponse {
  responseCode: string;
  responseMessage: string;
  data: string;
  account_activation_requested: string;
  agent_pin_set: string;
  profile: any;
  responseData: Make[];
}
interface Model {
  VEHICLE_MODEL_CODE: string;
  VEHICLE_MODEL_MAKE_CODE: string;
  VEHICLE_MODEL_DESC: string;
  VEHICLE_MODEL_SECOND_DESC: string;
  DISPLAY_SHORT_NAME: string;
}
interface ModelResponse {
  responseCode: string;
  responseMessage: string;
  data: string;
  account_activation_requested: string;
  agent_pin_set: string;
  profile: any;
  responseData: Model[];
}
interface coverType {
  value: string;       // unique select key — same as viewValue
  viewValue: string;   // human-readable label / product_description
  productCode: string; // actual API product code (e.g. '201', '202', '203')
  hide: boolean;
}

interface scheduleTypeResponse {
  responseCode: string;
  responseMessage: string;
  data: {
    totalItems: number;
    risks: scheduleType[];
  };
}

interface scheduleType {
  tabledCode: string;
  tabledDesignation: string;
  HIDE: boolean;
}

interface CurrencyResponse {
  responseCode: string;
  responseMessage: string;
  data: {
    totalItems: number;
    totalPages: number;
    currentPage: number;
    currencies: Currency[];
  };
}

interface Color {
  tabledCode: string;
  tabledDesignation: string;
  DISPLAY_SHORT_NAME: string;
}

interface colorResponse {
  responseCode: string;
  responseMessage: string;
  data: {
    colors: Color[];
  };
}

interface duration {
  value: string;
  viewValue: string;
  days: string;
  hide: boolean
}

interface BodyType {
  tabledCode: string;
  tabledDesignation: string;
}

interface QuoteResponse {
  responseCode: string;
  responseMessage: string;
  responseData: string;
  responseNumber: string;
}

interface BodyTypeResponse {
  responseCode: string;
  data: {
    bodyTypes: BodyType[];
  };
}

interface year {
  value: string;
  viewValue: string;
}


interface Currency {
  currency: string;
  currencyValue: number;
}
interface accessList {
  value: string;
  viewValue: string;
}


var i: number;

//var arrayYear = [];


@Component({
  selector: 'app-fleet-motor-quote',
  templateUrl: './fleet-motor-quote.component.html',
  styleUrls: ['./fleet-motor-quote.component.scss'],
  providers: [DatePipe]
})



export class FleetMotorQuoteComponent implements OnInit {
  appuser: any;
  //customer
  searchCustomerCtrl = new FormControl();
  customer_email = new FormControl();
  customer_phone = new FormControl();
  customer_date_of_birth = new FormControl();
  customer_ghana_card_number = new FormControl();
  product = new FormControl();
  inception_date = new FormControl();
  expiry_date = new FormControl();

  filteredCustomers: CustomerProfile[];

  //make
  searchMakeCtrl = new FormControl();
  loadedMakes: Make[];
  filteredMakes: Make[];

  //model
  searchModelCtrl = new FormControl();
  loadedModels: Model[] = [];
  filteredModels: Model[] = [];

  //color
  //color
  searchColorCtrl = new FormControl();
  loadedColors: Color[] = [];
  filteredColors: Color[] = [];

  //loadings
  isCustomerLoading: boolean = false;
  isMakeLoading: boolean = false;
  isModelLoading: boolean = false;
  isColorLoading: boolean = false;

  // ── Client search bar state ──────────────────────────────
  clientSearchBy: 'clientCode' | 'phone' | 'email' | 'ghCardNumber' = 'phone';
  clientSearchValue: string = '';
  isClientSearchLoading: boolean = false;
  clientSearchError: string = '';

  //is renewal
  renewal: boolean = false
  new: boolean = false
  disableCurrency = false
  annual: boolean = true

  //payload for submitting quote
  payload: any = {};
  filterClientPayload: any = {};

  coverData: coverType[] = [
    { value: 'STANBIC MOTOR THIRD PARTY ONLY', viewValue: 'STANBIC MOTOR THIRD PARTY ONLY', productCode: '203', hide: false },
    { value: 'STANBIC MOTOR COMPREHENSIVE', viewValue: 'STANBIC MOTOR COMPREHENSIVE', productCode: '201', hide: false },
    { value: 'STANBIC MOTOR THIRD PARTY FIRE & THEFT', viewValue: 'STANBIC MOTOR THIRD PARTY FIRE & THEFT', productCode: '202', hide: false },
    { value: 'STANBIC MOTOR EXECUTIVE', viewValue: 'STANBIC MOTOR EXECUTIVE', productCode: '201', hide: false },
    { value: 'FNB MOTOR THIRD PARTY ONLY', viewValue: 'FNB MOTOR THIRD PARTY ONLY', productCode: '203', hide: false },
    { value: 'FNB MOTOR COMPREHENSIVE', viewValue: 'FNB MOTOR COMPREHENSIVE', productCode: '201', hide: false },
    { value: 'FNB MOTOR THIRD PARTY FIRE & THEFT', viewValue: 'FNB MOTOR THIRD PARTY FIRE & THEFT', productCode: '202', hide: false },
    { value: 'FNB MOTOR EXECUTIVE', viewValue: 'FNB MOTOR EXECUTIVE', productCode: '201', hide: false },
    { value: 'ABSA MOTOR THIRD PARTY ONLY', viewValue: 'ABSA MOTOR THIRD PARTY ONLY', productCode: '203', hide: false },
    { value: 'ABSA MOTOR COMPREHENSIVE', viewValue: 'ABSA MOTOR COMPREHENSIVE', productCode: '201', hide: false },
    { value: 'ABSA MOTOR THIRD PARTY FIRE & THEFT', viewValue: 'ABSA MOTOR THIRD PARTY FIRE & THEFT', productCode: '202', hide: false },
  ];

  dobStartAt = new Date(moment(moment().format('YYYY-MM-DD')).subtract(18, 'years').format('YYYY-MM-DD'))

  //schedules and risks
  scheduleData: scheduleType[] = [];

  isNewCustomer: true;
  bodyData: BodyType[] = [];

  durationData: duration[] = [
    { value: 'annual', viewValue: 'Annual Term', days: '365', hide: false },
    { value: 'shortrate', viewValue: 'Short Term', days: '1', hide: false },
    //{ value: '03', viewValue: 'Prorata Term', days: '1', hide: false }
  ];

  yearData: year[] = [];

  currencyData: Currency[] = []

  accessData: accessList[] = [
    { value: "0", viewValue: "0" },
    { value: "1", viewValue: "1" },
    { value: "2", viewValue: "2" },
    { value: "3", viewValue: "3" },
    { value: "4", viewValue: "4" },
    { value: "5", viewValue: "5" },
    { value: "6", viewValue: "Above 5" },
  ]

  //selected records from dialogs
  selectedCustomer: CustomerProfile = {
    CLIENT_CODE: "",
    CLIENT_TYPE: "",
    CLIENT_FAMILY_NAME: "",
    CLIENT_HOME_MOBILE: "",
    CLIENT_FIRST_NAME: "",
    CLIENT_HOME_EMAIL: "",
    CLIENT_DATE_OF_BIRTH: "",
    DISPLAY_NAME: "",
    DISPLAY_SHORT_NAME: "",
    isNewCustomer: false
  };
  selectedMake: Make = {
    VEHICLE_MAKE_CODE: "",
    VEHICLE_MAKE_DESC: "",
    DISPLAY_SHORT_NAME: ""
  }
  selectedModel: Model = {
    VEHICLE_MODEL_CODE: "",
    VEHICLE_MODEL_MAKE_CODE: "",
    VEHICLE_MODEL_DESC: "",
    VEHICLE_MODEL_SECOND_DESC: "",
    DISPLAY_SHORT_NAME: ""
  }
  selectedColor: Color = {
    tabledCode: "",
    tabledDesignation: "",
    DISPLAY_SHORT_NAME: ""
  }
  //searchCustomerDialogValue :any;
  //prepare quote json
  confirmedQuote: boolean = false;
  errors = {}
  selectedMethod: string;

  //is processing
  processing = false;
  renewal_checked: any = "";

  // quote: any = {
  //   edit_mode: false,
  //   agent_id: "VAN-900913",
  //   prepared_by: "",
  //   module: "agent",
  //   status_of_client: "new",
  //   vehicle_registration: "",
  //   make: "",
  //   model: "",
  //   chasis_number: "",
  //   year_of_manufacture: "",
  //   body_type_code: "",
  //   seats: 5,
  //   currency_code: "GHC",
  //   cubic_capacity: "",
  //   fleet: null,
  //   exchange_rate: '1',
  //   cover_type_code: "",
  //   cover_name: "",
  //   schedule_code: "",
  //   schedule_name: "",
  //   computation_type_code: "01",
  //   days_label: "Days",
  //   days: "365",
  //   _days: '',
  //   _months: '',
  //   comment: "",
  //   mileage: "",
  //   loadings: null,
  //   total_loadings: "0.0",
  //   short_rate: "100.0",
  //   color: "",
  //   fleet_import_id: null,
  //   schedule_id: null,
  //   customer_date_of_birth: "29-01-1988",
  //   customer_first_name: "",
  //   customer_last_name: "",
  //   customer_other_names: "",
  //   customer_email: "",
  //   customer_phone: "",
  //   customer_reference: "",
  //   customer_branch_code: "H1",
  //   customer_type_code: "01",
  //   intermediary_number: "AGT-MAXk-0000022",
  //   intermediary_nic_registration_number: "NIC/MC/020",
  //   intermediary_first_name: "dd",
  //   intermediary_last_name: "sd",
  //   intermediary_other_names: "",
  //   intermediary_phone: "",
  //   intermediary_email: "",
  //   intermediary_type_code: "04",
  //   intermediary_branch_code: "502",
  //   branch_code: "",
  //   cost_of_car: "",
  //   insurance_type: "",
  //   rate: "",
  //   managerEmail: "",
  //   total_premium: "",
  //   invoice: "",
  //   date: "",
  //   date_of_birth: "",
  //   term: "",
  //   inception_date: new Date(),
  //   expiry_date: "",
  //   sum_insured: "",
  //   applicable_accesses: [],
  //   excess_buy_back: false,
  //   tppd: false,
  //   tppd_value: 0.00,
  //   pa: false,
  //   pa_value: 0,
  //   ncd: false,
  //   ncd_value: "0",
  //   fd: false,
  //   vehicle_age_loading: false,
  //   cc_loading: false,
  //   customer_code: "",

  //   //toggle applicable access
  //   can_excess_buy: true,
  //   check_excess_buy: false,
  //   can_tppd_limit: true,
  //   check_tppd_limit: false,
  //   can_pa: true,
  //   check_pa: false,
  //   can_ncd: false,
  //   check_ncd: false,
  //   can_discount: false,
  //   check_discount: false,
  //   can_fd: true,
  //   check_fd: false,
  //   can_vehicle_age_loading: true,
  //   check_vehicle_age_loading: false,
  //   can_cc_loading: true,
  //   check_cc_loading: false,
  //   type: "",
  //   digital_address: "",
  //   id_type: "",
  //   id_number: "",
  //   tin: "",
  //   policy_no: "",

  //   //legacy values
  //   inputted_discount: "0",
  //   legacy_policy_sequence: "",
  //   legacy_total_premium: "",
  //   legacy_tppd_limit: "",
  //   legacy_excess_type_code: "",
  //   legacy_cc_added: "",
  //   legacy_age_added: "",
  //   legacy_additional_pa_amt: "",
  //   legacy_policy_number: "",

  //   gen_comments: ""

  // }

  quote: any = {
    policy_sequence: null,
    legacy_policy_sequence: null,
    legacy_policy_number: null,
    policy_company: null,
    policy_branch: null,
    policy_office: null,
    broker_user_code: null,
    policy_lob: "",
    policy_status: null,
    policy_status_reason: null,
    product: "",
    duration_type: "",
    agent_code: null,
    client_code: null,
    module: "",
    prepared_by: "",
    status_of_client: "new",
    status: "active",
    currency_code: "GHS",
    fleet: null,
    exchange_rate: 1.00,
    quote_days: 365,
    days_label: "Days",
    quote_months: null,
    inception_date: "",
    expiry_date: "",
    total_premium: 0.00,
    total_premium_cv: 0.00,
    holl_recover_care_fee: 0.00,
    holl_policy_admin_fee: 0.00,
    total_banca_premium: 0.00,
    pay_installment: false,
    monthly_installment: 0.00,
    upfront_premium: 0.00,
    customer_first_name: "",
    customer_last_name: "",
    customer_email: "",
    customer_phone: "",
    customer_date_of_birth: "",
    customer_ghana_card_number: "",
    customer_type_code: "01",
    intermediary_first_name: "",
    intermediary_last_name: "",
    intermediary_email: "",
    intermediary_phone: "",
    product_description: null,
    platform: "Webapp",
    quote_objects: [{
      objecth_sequence: null,
      objecth_id: null,
      vehicle_registration: "",
      make: "",
      make_code: null,
      quote_model: "",
      model_code: null,
      chasis_number: "",
      body_type_code: "",
      body_type_description: "",
      seats: null,
      year_of_manufacture: "",
      cubic_capacity: null,
      mileage: null,
      sum_insured: 0.00,
      sum_insured_rate: 0.00,
      sum_insured_rate_cv: 0.00,
      total_premium: 0.00,
      total_premium_cv: 0.00,
      color: "",
      color_code: "",
      risk: "",
      object_days: 365,
      object_months: null,
      inception_date: "",
      expiry_date: "",
      excess_amount: 0,
      excess_type_code: "ENA",
      legacy_excess_type_code: "ENA",
      tppd_limit: 0.00,
      tppd_rate: 0.00,
      legacy_tppd_limit: 0.00,
      additional_pa_amt: 0.00,
      additional_pa_charge: 0.00,
      legacy_additional_pa_amt: 0.00,
      legacy_additional_loading: 0.00,
      legacy_discount_amt: 0.00,
      personal_accident_charge: 0.00,
      additional_loading_amt: 0.00,
      additional_loading_rate: 0.00
    }],
    postRepairInspection: false,
    carHire: false,
    date_updated: "",
    date_created: ""
  }

  quoteDetails: any = [];


  selectedQuote: any;

  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  thirdFormGroup: FormGroup;
  fourthFormGroup: FormGroup;
  fifthFormGroup: FormGroup;
  sixthFormGroup: FormGroup;

  isOptional = false;

  formattedAmount;
  amount;

  todayDate = new Date();
  dateTxt: string;
  daysTextFieldInput: any;
  isStaff = false
  disableField = false;
  lblPay = "Approve Policy"
  paymentOption: 'full' | 'installment' = 'full';

  get payableAmount(): number {
    if (this.paymentOption === 'installment' && (this.quote.product === '201' || this.quote.product === '202')) {
      return this.quote.upfront_premium || 0;
    }
    return this.quote.total_banca_premium || this.quote.total_premium || 0;
  }

  get payableLabel(): string {
    if (this.paymentOption === 'installment' && (this.quote.product === '201' || this.quote.product === '202')) {
      return 'Pay Upfront';
    }
    return this.lblPay;
  }


  @ViewChild(MatPaginator) paginator: MatPaginator;

  length: number = 0
  pageIndex: number = 0
  pageSize: number = 5
  pageSizeOptions = [5]
  pageChange = false;

  dataSource = new MatTableDataSource();
  displayedColumns = ['no', 'policy_sequence', 'vehicle_registration', 'make_model', 'total_premium', 'inception_date', 'expiry_date', 'link', 'edit', 'print', 'delete']

  previousPram: any = ""
  previousLabel: String = "Back to products"
  pageHeaderLabel: String = "New Motor Insurance Quote - Fleet"
  responseCode: any;
  responseMessage: any;
  errorResponse: any;
  selectedPolicy: any = null;

  previousPremium = 0.00

  paymentChannel: string;
  quotePayloadBeforePayment: any


  constructor(
    private datePipe: DatePipe,
    private _formBuilder: FormBuilder,
    private service: DashboardService,
    private clientService: ClientService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private currencyPipe: CurrencyPipe,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<FleetMotorQuoteComponent>,
    public dialogRetryRef: MatDialog,
  ) {
    this.dateTxt = this.datePipe.transform(this.todayDate, 'dd/MM/yyyy');

    this.appuser = this.service.currentUser();
    //console.log("module>>>>" + this.appuser.role)


    if (!this.appuser)
      this.router.navigate(['']);

    this.renewal = false;
    this.selectedQuote = null;


  }

  ngOnInit() {

    this.quote.quote_days = this.durationData[0].days;
    this.daysTextFieldInput = parseInt(this.quote.quote_days);
    this.quote.inception_date = this.service.strDateToDBFormat(this.dateTxt);
    this.quote.duration_type = this.durationData[0].value;
    // Annual (default): expiry = start + 1 year - 1 day (leap-year safe, rated days = 365)
    this.quote.expiry_date = this.quote.duration_type === 'annual'
      ? moment(this.quote.inception_date).add(1, 'year').subtract(1, 'day').format('YYYY-MM-DD')
      : moment(this.quote.inception_date).subtract((this.quote.duration_type === 'shortrate' ? 1 : 0), 'days').add(parseInt(this.quote.quote_days), (this.quote.duration_type === 'shortrate' ? 'months' : 'days')).format('YYYY-MM-DD');
    this.previousPremium = parseFloat(localStorage.getItem('previousPremium'))



    //get querry params from url
    try {
      this.activatedRoute.queryParams.subscribe(
        params => {
          this.previousPram = params['previous'];
        });

    } catch (e) {
      // console.log(e)
    }



    console.log("quote-activity>>>>>>" + localStorage.getItem("quote_activity"))

    if (localStorage.getItem("quote_activity") == 'new') {


    } else if (this.previousPram == "quotes" || localStorage.getItem("quote_activity") == 'edit' || localStorage.getItem("quote_activity") == 'edit_add') {
      this.previousLabel = "Back to quotes"
      this.pageHeaderLabel = "Motor Insurance Quote - Details"
      this.displayedColumns = this.displayedColumns.filter(item => item !== 'print')

      //disable fields
      this.searchCustomerCtrl = new FormControl({ value: this.quote.client_code, disabled: true });
      this.new = true
      //this.customer_email = new FormControl({ value: this.quote.customer_email, disabled: true });
      //this.customer_phone = new FormControl({ value: this.quote.customer_phone, disabled: true });
      //this.customer_date_of_birth = new FormControl({ value: this.quote.customer_date_of_birth, disabled: true });
      //this.customer_ghana_card_number = new FormControl({ value: this.quote.customer_ghana_card_number, disabled: true });
      //this.renewal = true //this is to disable cover type, schedule, currency
      //this.inception_date = new FormControl({ value: this.quote.inception_date, disabled: true });

      this.annual = true


    } else if (this.previousPram == "policies" || localStorage.getItem("quote_activity") == 'policy_info_temp' || localStorage.getItem("quote_activity") == 'policy_info' || localStorage.getItem("quote_activity") == 'info_for_print') {

      if (localStorage.getItem("quote_activity") == 'info_for_print') {
        this.previousLabel = "Back to documents"
      } else {
        this.previousLabel = "Back to policies"
      }

      this.pageHeaderLabel = "Motor Insurance Policy - Details"
      this.displayedColumns = this.displayedColumns.filter(item => item !== 'edit')
      this.displayedColumns = this.displayedColumns.filter(item => item !== 'delete')
      //disable fields
      this.searchCustomerCtrl = new FormControl({ value: this.quote.client_code, disabled: true });
      this.customer_email = new FormControl({ value: this.quote.customer_email, disabled: true });
      this.customer_phone = new FormControl({ value: this.quote.customer_phone, disabled: true });
      this.customer_date_of_birth = new FormControl({ value: this.quote.customer_date_of_birth, disabled: true });
      this.customer_ghana_card_number = new FormControl({ value: this.quote.customer_ghana_card_number, disabled: true });
      this.renewal = true //this is to disable cover type, schedule, currency
      this.inception_date = new FormControl({ value: this.quote.inception_date, disabled: true });
      this.annual = true

      this.quote = JSON.parse(localStorage.getItem("motor-quote"))

      //populate fields with quote data
      this.populateQuoteValues()
      this.loadPolicyVehicles()


    } else if (localStorage.getItem("quote_activity") == 'policy_renewals') {
      // Deliberately NOT gated on this.previousPram == "renewals" — that comes from the
      // ?previous=renewals URL query param, which stays in the URL across a page refresh.
      // loadPolicyRenewals() below cascades into createNewRenewalQuote() (POST /quotes/create),
      // so gating on the URL alone would re-create the renewal quote on every refresh even
      // after quote_activity had already advanced past 'policy_renewals'. quote_activity is
      // the actual up-to-date signal for "renewal quote not yet created".
      this.previousLabel = "Back to policy renewals"
      this.pageHeaderLabel = "Motor Insurance Policy Renewal - Details"
      this.lblPay = "Pay Now"
      this.displayedColumns = this.displayedColumns.filter(item => item !== 'print')

      //disable fields
      this.searchCustomerCtrl = new FormControl({ value: this.quote.client_code, disabled: true });
      this.renewal = true //this is to disable cover type, schedule, currency
      //this.annual = true

      this.quote = JSON.parse(localStorage.getItem("motor-quote"))
      this.quote.status_of_client = "renew"

      console.log("quote_activity===> " + localStorage.getItem("quote_activity"))

      //populate fields with quote data
      //this.populateQuoteValues()
      this.loadPolicyRenewals()


    } else if (localStorage.getItem("quote_activity") == 'policy_renewals_edit_add' || localStorage.getItem("quote_activity") == 'policy_renewals_edit') {
      this.previousLabel = "Back to policy renewals"
      this.pageHeaderLabel = "Motor Insurance Policy Renewal - Details"
      this.lblPay = "Pay Now"
      this.displayedColumns = this.displayedColumns.filter(item => item !== 'print')

      //disable fields
      this.searchCustomerCtrl = new FormControl({ value: this.quote.client_code, disabled: true });
      this.renewal = true //this is to disable cover type, schedule, currency
      //this.annual = true

      this.quote = JSON.parse(localStorage.getItem("motor-quote"))
      this.quote.status_of_client = "renew"


      this.loadQuoteVehicles()

    }

    if (localStorage.getItem("motor-quote") && localStorage.getItem("quote_activity") == 'edit' || localStorage.getItem("quote_activity") == 'edit_add' || localStorage.getItem("quote_activity") == 'new_add') {
      this.quote = JSON.parse(localStorage.getItem("motor-quote"))
      //console.log("motor-quote>>>>" + JSON.stringify(this.quote))

      //populate fields with quote data
      this.populateQuoteValues()
      this.loadQuoteVehicles()


    }



    if (history.state.renewal) {
      this.renewal = history.state.renewal
      this.renewal_checked = 'renew'
    }

    //   if (this.selectedQuote)
    //   this.searchCustomerCtrl = new FormControl({ value: this.selectedQuote.CLIENT_CODE.toString(), disabled: true });
    //   else if (this.appuser && this.appuser.role == 'client') {
    //   this.quote.customer_code = this.appuser.code;
    //   this.searchCustomerCtrl = new FormControl({ value: this.quote.customer_code, disabled: true });
    // }


    if (this.appuser.role == 'AGENT' || this.appuser.role == 'BROKER_USER') {
      this.quote.agent_code = this.appuser.code
      this.quote.intermediary_first_name = this.appuser.first_name === null ? this.appuser.last_name : this.appuser.first_name
      this.quote.intermediary_last_name = this.appuser.last_name === null ? this.appuser.first_name : this.appuser.last_name
      this.quote.intermediary_phone = this.appuser.phone
      this.quote.intermediary_email = this.appuser.email
      this.quote.prepared_by = this.appuser.first_name + " " + this.appuser.last_name


    } else if (this.appuser.role == 'CLIENT') {
      this.selectedCustomer = {
        CLIENT_CODE: this.appuser.client_id,
        CLIENT_FIRST_NAME: this.appuser.first_name,
        CLIENT_FAMILY_NAME: this.appuser.last_name,
        CLIENT_HOME_EMAIL: this.appuser.email,
        DISPLAY_SHORT_NAME: `${this.appuser.first_name} ${this.appuser.last_name}`,
        CLIENT_HOME_MOBILE: this.appuser.phone
      };

      console.log("appuser ---> " + JSON.stringify(this.appuser))

      this.quote.client_code = this.appuser.code
      this.searchCustomerCtrl = new FormControl({ value: this.quote.client_code, disabled: true });
      this.quote.customer_first_name = this.appuser.first_name
      this.quote.customer_last_name = this.appuser.last_name
      this.quote.customer_email = this.appuser.email
      this.quote.customer_phone = this.appuser.phone
      this.quote.customer_date_of_birth = this.service.strDateToDBFormat(this.appuser.dob)



    }



    if (this.appuser.code == '30741') {
      this.isStaff = true
    }





    this.selectedMethod = 'Mobile';

    // Filter cover types to only those matching the logged-in user's bank name
    this.filterCoverDataByBank();

    // this.onDaysChanged(parseInt(this.quote.quote_days))
    this.showCurrencies();
    this.onFilterCustomer();
    this.showColors();
    this.onFilterColor();


    try {
      this.activatedRoute.paramMap.subscribe(
        params => {
          this.paymentChannel = params.get('payment-channel');
          //this.paymentStatus = params.get('payment-status');
        }

      );

    } catch (e) {
      // console.log(e)
    }


    if (this.paymentChannel == 'ecobankpay') {
      this.quotePayloadBeforePayment = JSON.parse(localStorage.getItem('quotePayload'))
      console.log("quotePayloadBeforePayment====>" + this.quotePayloadBeforePayment.policy_sequence)

      this.transactionStatus()

    }







  }


  disableFields() { }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }



  //input change
  cubic_capacity_change(event) {
    for (let i = 0; i < this.scheduleData.length; i++)

      this.scheduleData[i].HIDE = false;
    if (!isNaN(+`${event.target.value}`) && parseFloat(event.target.value) > 3000) {
      for (let i = 0; i < this.scheduleData.length; i++) {
        if (this.scheduleData[i].tabledDesignation == 'OWN GOODS CARRYING Z.300 (UPTO - 3000 CC)')
          this.scheduleData[i].HIDE = true;
      }
    }
    else if (!isNaN(+`${event.target.value}`) && parseFloat(event.target.value) <= 3000) {
      for (let i = 0; i < this.scheduleData.length; i++) {
        if (this.scheduleData[i].tabledDesignation == 'OWN GOODS CARRYING Z.300 (ABOVE - 3000 CC)')
          this.scheduleData[i].HIDE = true;
      }
    }
  }



  populateQuoteValues() {
    console.log('populateQuoteValues InceptionDate>>>>>>> ' + this.quote.inception_date)

    this.quote.inception_date = this.service.strDateToDBFormat(this.quote.inception_date)
    this.quote.expiry_date = this.service.strDateToDBFormat(this.quote.expiry_date)
    this.daysTextFieldInput = this.quote.quote_days.toString()
    this.quote.customer_date_of_birth = this.service.strDateToDBFormat(this.quote.customer_date_of_birth)
    this.quote.product = this.quote.product.toString()
    this.quote.duration_type = this.quote.duration_type.toString()

    // Re-derive product_description / product code from coverData.
    // Priority 1: exact viewValue match  (e.g. "STANBIC MOTOR COMPREHENSIVE")
    // Priority 2: partial match — API may return a suffix like "MOTOR COMPREHENSIVE"
    //             without the bank prefix, so find the first entry whose viewValue
    //             ends with the stored description (case-insensitive).
    // Priority 3: fall back to productCode match (first hit).
    if (this.quote.product_description) {
      const desc = this.quote.product_description.trim().toUpperCase();

      const exactMatch = this.coverData.find(c => c.viewValue.toUpperCase() === desc);
      if (exactMatch) {
        this.quote.product = exactMatch.productCode;
        this.quote.product_description = exactMatch.value; // normalise to local value key
      } else {
        // Partial / suffix match (handles "MOTOR COMPREHENSIVE" → "STANBIC MOTOR COMPREHENSIVE")
        const partialMatch = this.coverData.find(c => c.viewValue.toUpperCase().endsWith(desc));
        if (partialMatch) {
          this.quote.product = partialMatch.productCode;
          this.quote.product_description = partialMatch.value;
        } else {
          // Last resort: match by productCode
          const matchedByCode = this.coverData.find(c => c.productCode === this.quote.product);
          if (matchedByCode) {
            this.quote.product_description = matchedByCode.value;
          }
        }
      }
    } else {
      // No description stored — best-effort match by productCode (first hit)
      const matchedByCode = this.coverData.find(c => c.productCode === this.quote.product);
      this.quote.product_description = matchedByCode ? matchedByCode.value : null;
    }

    console.log("this.quote.inception_date >>>>>" + this.quote.inception_date)
    console.log(" this.quote.customer_date_of_birth >>>>>" + this.quote.customer_date_of_birth)

    // Restore top-level additional covers flags (default to false if not present)
    if (this.quote.postRepairInspection === undefined) { this.quote.postRepairInspection = false; }
    if (this.quote.carHire === undefined) { this.quote.carHire = false; }

  }

  // getVehiclesFromQuoteList() {
  //   this.dataSource.data = this.quote.quote_objects
  //   this.pageSize = 5
  //   this.length = this.quote.quote_objects.length
  // }


  loadQuoteVehicles = () => {
    this.payload = {
      module: "agent",
      page_size: "5",
      current_page: "0",
      policy_sequence: this.quote.policy_sequence
    }

     if (this.appuser.role === 'ADMIN') {
      this.payload = {
        ...this.payload,
        module: 'admin',
        banca: this.appuser.bankName || ''
      }
    } else if (this.appuser.role === 'CLIENT') {
      this.payload = {
        ...this.payload,
        module: 'client',
        client_code: this.appuser.code
      }
    } else if (this.appuser.role === 'AGENT') {
      this.payload = {
        ...this.payload,
        module: 'agent',
        agent_code: this.appuser.code
      }
    } else if (this.appuser.role === 'BROKER_USER') {
      this.payload = {
        ...this.payload,
        module: 'broker-user',
        broker_user_code: this.appuser.code
      }
    } else { }



    this.service.swalAlart.showLoading();
    this.service.getquote(this.payload)
      .toPromise()
      .then((data: any) => {
        if (!data || data.responseCode !== '000' || !data.pageData || !data.pageData.content || data.pageData.content.length === 0) {
          this.service.swalAlart.close();
          this.service.swalAlart.fire({
            title: 'Failed',
            text: (data && data.responseMessage) || 'Could not load this quote\'s vehicle details. Please try again.',
            icon: 'error',
          });
          return;
        }

        this.quoteDetails = data.pageData.content
        const selectedQuote = this.quoteDetails.find((r: any) => String(r.policy_sequence) === String(this.quote.policy_sequence));

        if (!selectedQuote) {
          this.service.swalAlart.close();
          this.service.swalAlart.fire({
            title: 'Failed',
            text: 'Could not find this vehicle in the response. Please try again.',
            icon: 'error',
          });
          return;
        }

        this.dataSource.data = selectedQuote.quote_objects
        this.pageSize = 5
        this.length = selectedQuote.quote_objects.length

        this.quote.total_premium = this.quoteDetails[0].total_premium
        this.quote.total_premium_cv = this.quoteDetails[0].total_premium_cv

        this.quote = data.pageData.content[0]
        console.log("motor-quote>>>>>" + JSON.stringify(this.quote))

        localStorage.setItem('motor-quote', JSON.stringify(this.quote))

        console.log("customer_date_of_birth >>>>>" + this.quote.customer_date_of_birth)

        this.populateQuoteValues()
        //this.onDaysChanged(parseInt(this.quote.quote_days))




        //this.quote.quote_objects = selectedQuote.quote_objects


        this.service.swalAlart.close();
      }).catch(error => {
        this.service.swalAlart.close();
        this.service.swalAlart.fire({
          title: 'Failed',
          text: (error.error && error.error.responseMessage) || 'Something went wrong loading vehicle details.',
          icon: 'error',
        });
      })

  }

  loadPolicyRenewals = () => {
    this.payload = {
      module: "client",
      page_size: "5",
      current_page: "0",
      client_code: this.quote.client_code,
      policy_sequence: this.quote.policy_sequence
    }

    if (this.appuser.role === 'ADMIN') {
      this.payload = {
        ...this.payload,
        module: 'admin',
        banca: this.appuser.bankName || ''
      }
    } else if (this.appuser.role === 'AGENT') {
      this.payload = {
        ...this.payload,
        module: 'agent',
        agent_code: this.appuser.code
      }
    } else if (this.appuser.role === 'BROKER_USER') {
      this.payload = {
        ...this.payload,
        module: 'broker-user',
        broker_user_code: this.appuser.code
      }
    } else { }





    this.service.swalAlart.showLoading();
    this.service.getPoliciesForRenewal(this.payload)
      .toPromise()
      .then((data: any) => {
        this.quoteDetails = data.pageData.content
        const selectedQuote = this.quoteDetails.find((r: any) => String(r.policy_sequence) === String(this.quote.policy_sequence));

        if (!selectedQuote) {
          this.service.swalAlart.close();
          this.service.swalAlart.fire({
            title: 'Failed',
            text: 'Could not load this policy\'s vehicle details. Please go back and try again.',
            icon: 'error',
          });
          return;
        }

        this.dataSource.data = selectedQuote.quote_objects
        this.pageSize = 5
        this.length = selectedQuote.quote_objects.length

        this.quote.total_premium = this.quoteDetails[0].total_premium
        this.quote.total_premium_cv = this.quoteDetails[0].total_premium_cv

        this.quote = data.pageData.content[0]
        console.log("motor-quote>>>>>" + JSON.stringify(this.quote))

        localStorage.setItem('motor-quote', JSON.stringify(this.quote))
        localStorage.setItem('previousPremium', this.quote.total_premium)

        this.previousPremium = parseFloat(localStorage.getItem('previousPremium'))


        console.log("quote-duration_type>>>>>>" + this.quote.duration_type)
        if (this.quote.duration_type == 'shortrate') {
          this.annual = false
        } else {
          this.annual = true
        }


        this.onPolicyExpiry()


        this.service.swalAlart.close();
      }).catch(error => {
        this.service.swalAlart.close();
      })

  }

  onPolicyExpiry() {
    // this.quote.quote_days = 365
    // this.daysTextFieldInput = this.quote.quote_days.toString()
    this.quote.customer_date_of_birth = this.service.strDateToDBFormat(this.quote.customer_date_of_birth)
    this.quote.product = this.quote.product.toString()
    this.quote.duration_type = this.quote.duration_type.toString()

    let todayDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    let expiredDate = this.datePipe.transform(this.service.strDateToDBFormat(this.quote.expiry_date), 'yyyy-MM-dd');
    console.log('todayDate>>>>>>', todayDate)
    console.log('expiredDate>>>>>', expiredDate)

    console.log("quote_days>>>>>>" + this.quote.quote_days.toString())
    console.log("duration_type>>>>>>" + this.quote.duration_type.toString())

    if (this.quote.duration_type == "shortrate") {
      this.daysTextFieldInput = this.quote.quote_days.toString()
      let days = parseInt(this.quote.quote_days);

      console.log("inception_date>>>>>>" + this.quote.inception_date)
      //this.quote.inception_date = this.datePipe.transform(this.service.strDateToDBFormat(this.quote.inception_date), 'yyyy-MM-dd');
      this.quote.inception_date = todayDate

      let start_date = this.quote.inception_date ? moment(this.quote.inception_date).format('YYYY-MM-DD') : null;
      let end_date = moment(start_date).add(!isNaN(+`${days}`) ? days : 1, 'days').format('YYYY-MM-DD');
      console.log("end_date>>>>>>" + end_date)

      this.quote.expiry_date = end_date


    } else {
      this.quote.quote_days = 365
      this.daysTextFieldInput = this.quote.quote_days.toString()

      if (todayDate >= expiredDate) {
        console.log('---policy expired----');
        this.quote.inception_date = todayDate
        this.quote.expiry_date = moment(this.quote.inception_date).subtract((this.quote.duration_type == 'shortrate' ? 1 : 0), 'days').add(parseInt(this.quote.quote_days) >= 365 ? 365 : parseInt(this.quote.quote_days), (this.quote.duration_type == 'shortrate' ? 'months' : 'days')).format('YYYY-MM-DD');

      } else {
        console.log('---policy not expired yet-----');
        this.quote.inception_date = todayDate
        this.quote.expiry_date = moment(this.quote.inception_date).subtract((this.quote.duration_type == 'shortrate' ? 1 : 0), 'days').add(parseInt(this.quote.quote_days) >= 365 ? 365 : parseInt(this.quote.quote_days), (this.quote.duration_type == 'shortrate' ? 'months' : 'days')).format('YYYY-MM-DD');

        // this.quote.inception_date = moment(this.service.strDateToDBFormat(this.quote.expiry_date)).add(1, 'days').format('YYYY-MM-DD')
        // this.quote.expiry_date = moment(this.quote.inception_date).subtract(1, 'days').add(1, 'years').format('YYYY-MM-DD');

      }

    }




    this.initRenewal()
  }

  initRenewal = () => {
    this.processing = true;
    let prepared_by = `${this.appuser.first_name ? this.appuser.first_name : ''} ${this.appuser.last_name ? this.appuser.last_name : ''}`.trim();

    this.quote.prepared_by = prepared_by
    this.quote.policy_branch = this.appuser.agency || '1'
    this.quote.policy_office = this.appuser.agency || '1'
    this.quote.fleet = true
    this.quote.module = this.appuser.role.toLowerCase(),
      //this.quote.status_of_client = (this.renewal_checked == 'renew' ? 'renew' : 'new'),

      console.log("post inception_date>>> " + this.quote.inception_date)
    console.log("post expiry date>>>>> " + this.quote.expiry_date)

    this.quote.customer_date_of_birth = moment(this.quote.customer_date_of_birth).format('DD/MM/YYYY'),
      this.quote.inception_date = moment(this.quote.inception_date).format('DD/MM/YYYY'),
      this.quote.expiry_date = moment(this.quote.expiry_date).format('DD/MM/YYYY'),


      // this.quote.quote_objects[this.objecth_position].inception_date = this.quote.inception_date
      // this.quote.quote_objects[this.objecth_position].expiry_date = this.quote.expiry_date
      this.quote.client_code = this.quote.client_code,
      this.quote.policy_lob = "20",
      this.quote.platform = "Webapp"
    //this.quote.quote_objects[this.objecth_position].object_days = this.quote.quote_days

    this.quote.date_created = ""
    this.quote.updated = ""
    this.quote.status_of_client = "renew"

    if (this.appuser.role == 'AGENT') {
      this.quote = {
        ...this.quote,
        agent_code: this.appuser.code.toString(),
        client_code: this.quote.client_code.toString(),
        broker_user_code: '',
      }
    }
    else if (this.appuser.role == 'CLIENT') {
      this.quote = {
        ...this.quote,
        agent_code: '',
        client_code: this.appuser.code.toString(),
        broker_user_code: '',
      }
    } else if (this.appuser.role == 'BROKER_USER') {
      this.quote = {
        ...this.quote,
        agent_code: this.appuser.broker_user_main_broker_code.toString(),
        client_code: this.quote.client_code.toString(),
        broker_user_code: this.appuser.code.toString(),
      }
    } else {
      // ADMIN / STAFF or any other role — use appuser.code as the agent_code
      this.quote = {
        ...this.quote,
        agent_code: this.appuser.code ? this.appuser.code.toString() : '',
        client_code: this.quote.client_code.toString(),
        broker_user_code: '',
      }
    }

    //connect to api
    this.createNewRenewalQuote(this.quote)

  }

  createNewRenewalQuote(postPayload: any) {
    postPayload.quote_activity = "First"

    this.service.swalAlart.showLoading()
    this.service.createQuote(postPayload)
      .toPromise()
      .then((response: any) => {
        this.service.swalAlart.close()

        this.responseCode = response.responseCode
        this.responseMessage = response.responseMessage
        this.errorResponse = response.errorResponse

        if (response.responseCode == '000') {
          console.log("policy_sequence>>>>>" + response.responseObject)

          // /quotes/create already returns the fully computed quote + quote_objects
          // (premiums, NCD discount, etc.) — populate directly instead of an extra
          // /quotes/get_quotes round trip.
          this.quote = response.responseObject
          this.dataSource.data = response.responseObject.quote_objects || []
          this.pageSize = 5
          this.length = this.dataSource.data.length

          localStorage.setItem('motor-quote', JSON.stringify(this.quote))
          if (localStorage.getItem("quote_activity") == 'new' || localStorage.getItem("quote_activity") == 'new_add') {
            localStorage.setItem('quote_activity', 'edit_add')

          } else if (localStorage.getItem("quote_activity") == 'policy_renewals') {
            localStorage.setItem('quote_activity', 'policy_renewals_edit_add')
          }

          this.populateQuoteValues()

          swal.fire({
            icon: 'success',
            text: 'New renewal premium computation successful',
            timer: 15000,
            showConfirmButton: true
          });

          //this.router.navigate(["/fleet-motor-quote"])


        } else if (response.responseCode == 'E60') {
          this.service.swalAlart.fire({
            title: 'Failed',
            text: "Sorry, you cannot renew policy belonging to another agent. Kindly contact your branch office.",
            icon: 'warning',
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then(result => {
            if (result) {
              this.populateQuoteValues()
              this.router.navigate(["/renewpolicy"])
            }
          })

        } else if (response.responseCode == 'E57') {
          this.service.swalAlart.fire({
            title: 'Failed',
            text: "Sorry, you cannot renew policy belonging to a different branch. Kindly contact your branch office.",
            icon: 'warning',
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then(result => {
            if (result) {
              this.populateQuoteValues()
              this.router.navigate(["/renewpolicy"])
            }
          })

        } else if (response.responseCode == 'E56') {
          this.service.swalAlart.fire({
            title: 'Failed',
            text: "Sorry, we couldn't find any branch associated with this account. Kindly contact your branch office.",
            icon: 'warning',
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then(result => {
            if (result) {
              this.populateQuoteValues()
              this.router.navigate(["/renewpolicy"])
            }
          })

        } else if (response.responseCode == 'E54') {
          this.service.swalAlart.fire({
            title: 'Failed',
            text: "Sorry, this policy is not due for renewal.",
            icon: 'warning',
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then(result => {
            if (result) {
              this.populateQuoteValues()
              this.router.navigate(["/renewpolicy"])
            }
          })



        } else if (response.responseCode == '400') {
          this.service.swalAlart.fire({
            title: 'Failed',
            text: this.errorResponse,
            icon: 'warning',
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then(result => {
            if (result) {
              this.populateQuoteValues()
              this.router.navigate(["/renewpolicy"])
            }
          })
        }

        else {
          this.service.swalAlart.fire({
            title: 'Failed',
            text: this.responseMessage,
            icon: 'error',
          });
          this.populateQuoteValues()
          this.router.navigate(["/renewpolicy"])
        }

      }).catch(error => {
        console.log('Error', error)

        this.processing = false;
        this.service.swalAlart.close();
        this.service.swalAlart.fire({
          title: error.error.responseMessage,
          text: error.error.errorResponse,
          icon: 'error',
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then(result => {
          if (result) {
            this.populateQuoteValues()
            this.router.navigate(["/renewpolicy"])
          }
        })

      })
  }

  quoteLevelEdit(postPayload: any) {
    postPayload.quote_activity = "QuoteLevelEdit"

    this.service.swalAlart.showLoading()
    this.service.editVehicle(postPayload)
      .toPromise()
      .then((response: any) => {
        this.service.swalAlart.close()

        this.responseCode = response.responseCode
        this.responseMessage = response.responseMessage

        if (response.responseCode == '000') {
          this.loadQuoteVehicles()


          const dialogRef = this.dialog.open(SelectPaymentMethodComponent, {
            disableClose: true,
            width: '350px',
            data: {
              quotePayload: this.quote,
              method: null,
              total_premium: this.payableAmount,
              payment_option: this.paymentOption
            }
          });

          dialogRef.afterClosed().subscribe(result => {
            if (result.hasOwnProperty('data')) {
              this.confirmedQuote = result.data.confirmedQuote;
              this.selectedMethod = result.data.method;

              if (this.selectedMethod)
                this.confirmPin();

              this.validateForm();
            }
          });

        } else if (response.responseCode == '400') {
          this.service.swalAlart.fire({
            title: 'Failed',
            text: this.responseMessage,
            icon: 'error',
          });
          this.populateQuoteValues()
        }

        else {
          this.service.swalAlart.fire({
            title: 'Failed',
            text: this.responseMessage,
            icon: 'error',
          });
          this.populateQuoteValues()
        }

      }).catch(error => {
        //console.log('Error',error)
        this.processing = false;
        this.service.swalAlart.close();
        this.service.swalAlart.fire({
          title: 'Server Error',
          text: this.responseMessage,
          icon: 'error',
        });
        this.populateQuoteValues()
      })
  }

  quoteLevelEditChangedDuration(postPayload: any) {
    postPayload.quote_activity = "QuoteLevelEdit"

    this.service.swalAlart.showLoading()
    this.service.editVehicle(postPayload)
      .toPromise()
      .then((response: any) => {
        this.service.swalAlart.close()

        this.responseCode = response.responseCode
        this.responseMessage = response.responseMessage
        this.errorResponse = response.errorResponse

        if (response.responseCode == '000') {
          this.loadQuoteVehicles()

        } else if (response.responseCode == '400') {
          this.service.swalAlart.fire({
            title: 'Failed',
            text: this.responseMessage,
            icon: 'error',
          });
          this.populateQuoteValues()

        } else if (response.responseCode == '500') {
          this.service.swalAlart.fire({
            title: 'Failed',
            text: this.errorResponse,
            icon: 'error',
          });
          this.populateQuoteValues()
        }

        else {
          this.service.swalAlart.fire({
            title: 'Failed',
            text: this.responseMessage,
            icon: 'error',
          });
          this.populateQuoteValues()
        }

      }).catch(error => {
        //console.log('Error',error)
        this.processing = false;
        this.service.swalAlart.close();
        this.service.swalAlart.fire({
          title: error.error.responseMessage,
          text: error.error.errorResponse,
          icon: 'error',
        });
        this.populateQuoteValues()
      })
  }



  loadPolicyVehicles = () => {


    this.payload = {
      module: "agent",
      page_size: "5",
      current_page: "0",
      policy_sequence: this.quote.policy_sequence
    }

     if (this.appuser.role === 'ADMIN') {
      this.payload = {
        ...this.payload,
        module: 'admin',
        banca: this.appuser.bankName || ''
      }
    } else if (this.appuser.role === 'CLIENT') {
      this.payload = {
        ...this.payload,
        module: 'client',
        client_code: this.appuser.code
      }
    } else if (this.appuser.role === 'AGENT') {
      this.payload = {
        ...this.payload,
        module: 'agent',
        agent_code: this.appuser.code
      }
    } else if (this.appuser.role === 'BROKER_USER') {
      this.payload = {
        ...this.payload,
        module: 'broker-user',
        broker_user_code: this.appuser.code
      }

    } else if (this.appuser.role === 'BROKER_ADMIN') {
      console.log("loadPolicyVehicles ===> " + this.appuser.code)
      this.payload = {
        ...this.payload,
        module: 'agent',
        agent_code: this.appuser.code
      }

      this.displayedColumns = ['no', 'policy_sequence', 'vehicle_registration', 'make_model', 'total_premium', 'inception_date', 'expiry_date', 'link', 'print']



    } else { }


    let policyFilter = "today"
    if (localStorage.getItem("quote_activity") == 'policy_info_temp') {
      policyFilter = "today"

    } else {
      policyFilter = "all"

    }



    if (localStorage.getItem("quote_activity") == 'info_for_print') {

      let client_code = localStorage.getItem("selectedCustomerCode")
      let payload: any = {
        page_size: "5",
        current_page: "0",
        client_code: client_code,
        policy_sequence: this.quote.policy_sequence
      }

      this.service.swalAlart.showLoading();
      this.service.getPoliciesForDocuments(payload)
        .toPromise()
        .then((data: any) => {
          this.quoteDetails = data.pageData.content
          const selectedQuote = this.quoteDetails.find((r: any) => String(r.policy_sequence) === String(this.quote.policy_sequence));

          this.dataSource.data = selectedQuote.quote_objects
          this.pageSize = 5
          this.length = selectedQuote.quote_objects.length

          this.quote.total_premium = this.quoteDetails[0].total_premium
          this.quote.total_premium_cv = this.quoteDetails[0].total_premium_cv

          this.quote = data.pageData.content[0]
          console.log("motor-quote>>>>>" + JSON.stringify(this.quote))

          localStorage.setItem('motor-quote', JSON.stringify(this.quote))

          this.populateQuoteValues()

          this.service.swalAlart.close();
        }).catch(error => {
          this.service.swalAlart.close();
        })


    } else {

      this.service.swalAlart.showLoading();
      this.service.getPolicyInfo(this.payload, policyFilter)
        .toPromise()
        .then((data: any) => {
          this.quoteDetails = data.pageData.content
          const selectedQuote = this.quoteDetails.find((r: any) => String(r.policy_sequence) === String(this.quote.policy_sequence));

          this.dataSource.data = selectedQuote.quote_objects
          this.pageSize = 5
          this.length = selectedQuote.quote_objects.length

          this.quote.total_premium = this.quoteDetails[0].total_premium
          this.quote.total_premium_cv = this.quoteDetails[0].total_premium_cv

          this.quote = data.pageData.content[0]
          console.log("motor-quote>>>>>" + JSON.stringify(this.quote))

          localStorage.setItem('motor-quote', JSON.stringify(this.quote))

          this.populateQuoteValues()

          this.service.swalAlart.close();
        }).catch(error => {
          this.service.swalAlart.close();
        })

    }






  }


  /**
   * If the logged-in user belongs to a bank (appuser.bankName is set),
   * keep only the coverData entries whose value starts with a word that
   * appears in the bank name.
   *
   * Match strategy:
   *   Split bankName into individual words (e.g. "ABSA Bank" → ["ABSA", "Bank"]),
   *   then keep a cover entry if its value (uppercased) starts with ANY of those
   *   words (uppercased).  This means "ABSA Bank" matches "ABSA MOTOR …" but not
   *   "STANBIC MOTOR …" or "FNB MOTOR …".
   *
   * When no bankName is present (ADMIN with no bank, or agent) the full list is kept.
   */
  filterCoverDataByBank() {
    var bankName = this.appuser ? (this.appuser.bankName || '') : '';
    if (!bankName.trim()) {
      return; // no bank → show everything
    }

    // Map of full/common bank name variants → cover-value prefix used in coverData
    var aliasMap: { [key: string]: string } = {
      'FIRST NATIONAL BANK': 'FNB',
      'FIRST NATIONAL BANK GHANA': 'FNB',
      'FNB': 'FNB',
      'GHANA COMMERCIAL BANK': 'GCB',
      'GHANA COMMERCIAL BANK LTD': 'GCB',
      'GCB': 'GCB',
      'GCB BANK': 'GCB',
      'STANBIC BANK': 'STANBIC',
      'STANBIC BANK GHANA': 'STANBIC',
      'STANBIC BANK GHANA LTD': 'STANBIC',
      'STANBIC': 'STANBIC',
      'ABSA BANK': 'ABSA',
      'ABSA BANK GHANA': 'ABSA',
      'ABSA BANK GHANA LTD': 'ABSA',
      'ABSA': 'ABSA',
      'ECOBANK': 'ECOBANK',
      'ECOBANK GHANA': 'ECOBANK',
      'ECOBANK GHANA LTD': 'ECOBANK',
      'STANDARD CHARTERED': 'SCB',
      'STANDARD CHARTERED BANK': 'SCB',
      'STANDARD CHARTERED BANK GHANA': 'SCB',
      'ZENITH BANK': 'ZENITH',
      'ZENITH BANK GHANA': 'ZENITH',
      'FIDELITY BANK': 'FIDELITY',
      'FIDELITY BANK GHANA': 'FIDELITY',
      'ACCESS BANK': 'ACCESS',
      'ACCESS BANK GHANA': 'ACCESS',
      'UNIVERSAL MERCHANT BANK': 'UMB',
      'UMB': 'UMB',
      'REPUBLIC BANK': 'REPUBLIC',
      'REPUBLIC BANK GHANA': 'REPUBLIC',
      'PRUDENTIAL BANK': 'PRUDENTIAL',
      'SOCIETE GENERALE': 'SG',
      'SOCIETE GENERALE GHANA': 'SG',
      'CONSOLIDATED BANK GHANA': 'CBG',
      'CBG': 'CBG',
      'AGRICULTURAL DEVELOPMENT BANK': 'ADB',
      'ADB': 'ADB',
      'NATIONAL INVESTMENT BANK': 'NIB',
      'NIB': 'NIB',
      'CAL BANK': 'CAL',
      'CAL BANK LTD': 'CAL',
    };

    var normalised = bankName.toUpperCase().trim();
    var mapped = aliasMap[normalised];
    var bankWords: string[];

    if (mapped) {
      // Direct alias hit — use the known prefix
      bankWords = [mapped];
    } else {
      // Fall back: extract meaningful words from the bank name
      var skip = new Set(['OF', 'THE', 'AND', '&', 'LTD', 'LIMITED', 'PLC', 'BANK', 'GH', 'GHANA']);
      bankWords = normalised.split(/\s+/).filter(function(w) {
        return w.length > 1 && !skip.has(w);
      });
    }

    if (!bankWords.length) {
      return; // nothing useful to filter on
    }

    this.coverData = this.coverData.filter(function(cover) {
      var val = cover.value.toUpperCase();
      return bankWords.some(function(word) { return val.startsWith(word); });
    });
  }

  onCoverSelected(selectedValue: string) {
    // selectedValue is the unique description key (= viewValue).
    // Use productCode for the actual API product field.
    const matched = this.coverData.find(c => c.value === selectedValue);
    this.quote.product = matched ? matched.productCode : selectedValue;
    this.quote.product_description = matched ? matched.viewValue : null;
    console.log("coverType======= product:", this.quote.product, "description:", this.quote.product_description);

    //toggle applicable accesses
    this.quote.can_cc_loading = this.quote.can_vehicle_age_loading = this.quote.can_fd = this.quote.can_ncd = this.quote.can_pa = this.quote.can_tppd_limit = this.quote.can_excess_buy = true;
    this.quote.check_cc_loading = this.quote.check_vehicle_age_loading = this.quote.check_fd = this.quote.check_ncd = this.quote.check_pa = this.quote.check_tppd_limit = this.quote.check_excess_buy = false;


    if (this.quote.product === '203') {
      this.quote.check_excess_buy = this.quote.can_excess_buy = false
      this.quote.check_ncd = this.quote.can_ncd = false
      this.quote.check_fd = this.quote.can_fd = false
      this.quote.check_vehicle_age_loading = this.quote.can_vehicle_age_loading = false
      this.quote.check_cc_loading = this.quote.can_cc_loading = false
      this.quote.sum_insured = "0"

      this.quote.exchange_rate = "1"
      this.quote.currency_code = "GHS"
      this.disableCurrency = true

    } else {
      this.quote.sum_insured = ""

      this.disableCurrency = false
    }




    //hide prorata for thirdparty
    for (let i = 0; i < this.durationData.length; i++) {
      if (this.quote.product == '203' && this.durationData[i].value == '03')
        this.durationData[i].hide = true;
      else
        this.durationData[i].hide = false;
    }


    if (!this.quote.edit_mode) {
      // this.validateForm();
    }

  }

  onScheduleSelected(code: string) {
    //console.log("scheduleType=======" + code);
    this.quote.schedule_code = code;

    // this.validateForm();
  }

  //on term selection
  onDurationSelected() {
    console.log("onDurationSelected>>>>true")

    //Get the associated days to the term
    let durations = this.durationData.filter((duration: duration) => duration.value == this.quote.duration_type);

    if (durations.length > 0)
      this.quote.quote_days = durations[0].days;

    //recalculate the end date
    if (!isNaN(+`${this.quote.quote_days}`) && this.quote.inception_date)
      this.quote.expiry_date = moment(this.quote.inception_date).subtract((this.quote.duration_type == 'shortrate' ? 1 : 0), 'days').add(parseInt(this.quote.quote_days) >= 364 ? 364 : parseInt(this.quote.quote_days), (this.quote.duration_type == 'shortrate' ? 'months' : 'days')).format('YYYY-MM-DD');


    //change the days label to months when the term changes to short term
    if (this.quote.duration_type == 'shortrate') {

      this.quote.days_label = 'Days';
      let days = this.quote.quote_days = Math.abs(moment(moment(this.quote.inception_date).format('YYYY-MM-DD')).diff(moment(this.quote.expiry_date).format('YYYY-MM-DD'), 'days'));
      this.quote._days = days ? days : 1;
      this.quote._months = '';

      this.daysTextFieldInput = parseInt(this.quote.quote_days) + 2;
      this.annual = false;

      this.quote.quote_days = this.daysTextFieldInput


    } else if (this.quote.duration_type == 'annual' && this.quote.quote_days != '' && parseInt(this.quote.quote_days) >= 364) {

      // Annual: rated days is always 365; expiry = start + 1 year - 1 day (handles leap years correctly)
      this.quote.quote_days = 365;
      this.daysTextFieldInput = 365;
      this.annual = true;

      this.quote.expiry_date = moment(this.quote.inception_date).add(1, 'year').subtract(1, 'day').format('YYYY-MM-DD');



    } else {
      this.quote.days_label = 'Days';
      let days = this.quote.quote_days = Math.abs(moment(moment(this.quote.inception_date).format('YYYY-MM-DD')).diff(moment(this.quote.expiry_date).format('YYYY-MM-DD'), 'days'));
      this.quote._days = days ? days : 1;
      this.quote._months = '';

    }




    //hide thirdparty for prorata
    for (let i = 0; i < this.coverData.length; i++) {
      if (this.quote.duration_type == 'duration_type' && this.coverData[i].productCode == '203')
        this.coverData[i].hide = true;
      else
        this.coverData[i].hide = false;
    }



    //save quote level details for payment
    this.processing = true;
    let prepared_by = `${this.appuser.first_name ? this.appuser.first_name : ''} ${this.appuser.last_name ? this.appuser.last_name : ''}`.trim();

    this.quote.prepared_by = prepared_by
    this.quote.policy_branch = this.appuser.agency || '1'
    this.quote.policy_office = this.appuser.agency || '1'
    this.quote.fleet = true
    this.quote.module = this.appuser.role.toLowerCase(),
      //this.quote.status_of_client = (this.renewal_checked == 'renew' ? 'renew' : 'new'),

      console.log("post inception_date>>> " + this.quote.inception_date)
    console.log("post customer_date_of_birth>>>>> " + this.quote.customer_date_of_birth)

    if (this.quote.policy_sequence) {
      this.quote.customer_date_of_birth = moment(this.quote.customer_date_of_birth).format('DD/MM/YYYY')
      this.quote.inception_date = moment(this.quote.inception_date).format('DD/MM/YYYY')
      this.quote.expiry_date = moment(this.quote.expiry_date).format('DD/MM/YYYY')
    } else {
      this.quote.customer_date_of_birth = moment(this.quote.customer_date_of_birth).format('YYYY-MM-DD')
      this.quote.inception_date = moment(this.quote.inception_date).format('YYYY-MM-DD')
      this.quote.expiry_date = moment(this.quote.expiry_date).format('YYYY-MM-DD')

    }


    this.quote.client_code = this.quote.client_code
    this.quote.policy_lob = "20"
    this.quote.platform = "Webapp"

    this.quote.date_created = ""
    this.quote.updated = ""

    delete this.quote.quote_objects


    if (this.appuser.role == 'AGENT') {
      this.quote = {
        ...this.quote,
        agent_code: this.appuser.code.toString(),
        client_code: this.quote.client_code.toString(),
        broker_user_code: '',
      }
    }
    else if (this.appuser.role == 'CLIENT') {
      this.quote = {
        ...this.quote,
        agent_code: '',
        client_code: this.appuser.code.toString(),
        broker_user_code: '',
      }
    } else if (this.appuser.role == 'BROKER_USER') {
      this.quote = {
        ...this.quote,
        agent_code: this.appuser.broker_user_main_broker_code.toString(),
        client_code: this.quote.client_code.toString(),
        broker_user_code: this.appuser.code.toString(),
      }
    } else {
      // ADMIN / STAFF or any other role — use appuser.code as the agent_code
      this.quote = {
        ...this.quote,
        agent_code: this.appuser.code ? this.appuser.code.toString() : '',
        client_code: this.quote.client_code.toString(),
        broker_user_code: '',
      }
    }

    // //increase expiry date by 1 day and reduce by 1
    // this.quote.expiry_date =  moment(this.quote.inception_date).add(this.quote.quote_days + 1, 'days').format('YYYY-MM-DD');



    //connect to api
    if (this.quote.policy_sequence) {
      this.quoteLevelEditChangedDuration(this.quote)
    }



  }


  onBodySelected(code: string) {
    this.quote.body_type_code = code;

    // Find the body type from bodyData and assign its tabledDesignation
    const selectedBody = this.bodyData.find(body => body.tabledCode === code);
    if (selectedBody) {
      this.quote.body_type_description = selectedBody.tabledDesignation;
    }

    this.validateForm();
  }

  onYearSelected(code: string) {
    //console.log("year=======" + code);
    this.quote.year_of_manufacture = code;
    this.validateForm();
  }

  onCurrencySelected(code: string) {
    let selectedCurrency = this.currencyData.filter((currency: Currency) => currency.currency == code);

    if (selectedCurrency.length) {
      this.quote.exchange_rate = selectedCurrency[0].currencyValue.toString();
      this.quote.currency_code = code;
    }

    this.validateForm();
  }
  onNCDSelected(code: string) {
    this.quote.ncd_value = code;
  }


  onStartDateChanged() {
    console.log("onStartDateChanged")

    let inception_date = this.quote.inception_date ? moment(this.quote.inception_date).format('YYYY-MM-DD') : null;

    let days = parseInt(this.quote.quote_days);

    // For non-annual terms cap at 364 days; annual is handled separately below
    if (this.quote.duration_type !== 'annual' && days >= 365)
      days = 364;

    let expiry_date: string;
    if (this.quote.duration_type === 'annual') {
      // Annual: expiry = start + 1 year - 1 day (leap-year safe, rated days = 365)
      expiry_date = moment(inception_date).add(1, 'year').subtract(1, 'day').format('YYYY-MM-DD');
    } else {
      expiry_date = moment(inception_date).add(!isNaN(+`${days}`) ? days : 1, 'days').format('YYYY-MM-DD');
    }
    this.quote.expiry_date = expiry_date;

    if (this.quote.inception_date && this.quote.expiry_date) {
      if (this.quote.duration_type == 'annual') {
        // Annual: rated days always 365; expiry = start + 1 year - 1 day (leap-year safe)
        this.quote.quote_days = '365';
        this.daysTextFieldInput = 365;
        this.annual = true;

        this.quote.expiry_date = moment(this.quote.inception_date).add(1, 'year').subtract(1, 'day').format('YYYY-MM-DD');

      } else {
        this.quote.quote_days = this.quote._days = moment(expiry_date).diff(inception_date, 'days').toString();
        this.daysTextFieldInput = parseInt(this.quote.quote_days) + 2;
        this.quote.quote_days = this.daysTextFieldInput


        //  if(this.quote.term=='02')
        //  this.quote.days=this.quote._months=Math.round(moment(expiry_date).diff(inception_date,'days')/31);

      }
    }



    // //increase expiry date by 1 day
    // this.quote.expiry_date =  moment(inception_date).add(days + 1, 'days').format('YYYY-MM-DD');


    this.validateForm();

  }



  onEndDateChanged(date: Date) {
    let inception_date = this.quote.inception_date ? moment(this.quote.inception_date).format('YYYY-MM-DD') : null;

    let days = 0, months = 0;
    if (inception_date) {
      if (this.quote.duration_type == 'shortrate') {
        days = moment(moment(date).format('YYYY-MM-DD')).diff(inception_date, 'days');
        this.quote.quote_days = days.toString();

        this.daysTextFieldInput = parseInt(this.quote.quote_days) + 2;
        this.quote.quote_days = this.daysTextFieldInput


        // months=Math.round(moment(moment(date).format('YYYY-MM-DD')).add(1,'days').diff(inception_date,'days')/31);
        // this.quote.days=this.quote._months=this.quote._months=months;

        // if(this.quote.term=='02' && months==0){
        //  this.quote.term='03';
        //  this.quote.days_label="Days"
        // }
      }
      if (this.quote.duration_type != 'shortrate') {
        days = moment(moment(date).format('YYYY-MM-DD')).diff(inception_date, 'days');
        this.quote.quote_days = days.toString();

        this.daysTextFieldInput = parseInt(this.quote.quote_days);
        this.quote.quote_days = this.daysTextFieldInput

      }
    }

    if (days && days < 365 && this.quote.duration_type == 'annual') {
      months = moment(moment(date).format('YYYY-MM-DD')).diff(inception_date, 'months');

      if (months) {
        this.quote.days_label = "Days";
        this.quote.duration_type = 'shortrate';


        //this.quote.days_label="Months";
        //this.quote.term='02';
        //this.quote.days=months;

      }
      else {
        this.quote.days_label = "Days";
        this.quote.duration_type = 'prorata';
      }
    }
    else if (days == 365) {
      this.quote.duration_type = 'annual';
    }



    this.validateForm();




  }



  //Start Date dateFilters
  startDateFilter = (date: Date) => {
    return moment(moment(date).format('YYYY-MM-DD')).diff(moment().format('YYYY-MM-DD'), 'days') >= 0;
  }
  //End Date dateFilters
  endDateFilter = (date: Date) => {
    let diff = moment(moment(date).format('YYYY-MM-DD')).diff(moment(this.quote.inception_date).format('YYYY-MM-DD'), 'days');
    return diff > 0 && diff <= 364;
  }


  /* handle access changes===*/
  onExcessBuyBackChange(checked: boolean) {
    this.quote.excess_buy_back = checked;
  }
  onTppdChange(checked: boolean) {
    if (!checked)
      this.quote.tppd_value = 0;
    this.quote.tppd = checked;

  }
  onPaChange(checked: boolean) {
    if (!checked)
      this.quote.pa_value = 0;
    this.quote.pa = checked;

  }
  onNcdChange(checked: boolean) {
    if (!checked)
      this.quote.ncd_value = 0;
    this.quote.ncd = checked;

  }
  onFdChange(checked: boolean) {
    this.quote.fd = checked;
  }
  onVehicleAgeLoadingChange(checked: boolean) {
    this.quote.vehicle_age_loading = checked;
  }
  onCCLoadingChange(checked: boolean) {
    this.quote.cc_loading = checked;
  }
  onDiscountChange(checked: boolean) {
    if (!checked)
      this.quote.inputted_discount = 0;

    this.quote.additional_discount = checked;
  }
  onLoadingDiscountChange(checked: boolean) {
    if (!checked)
      this.quote.inputted_loading = 0;

    this.quote.loading_discount = checked;
  }


  onRenewalChange() {

    if (this.renewal_checked == 'renew')
      this.service.swalAlart.fire({
        text: "Premium computations for this policy will be treated as renewal.\nDo you wish to proceed?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: `Yes,Proceed`,
        reverseButtons: true
      })
        .then((dialogResponse) => {
          if (dialogResponse.hasOwnProperty('value') && dialogResponse.value == true) {
            this.renewal = true
            this.quote.edit_mode = true;
            this.quote.product = this.selectedQuote.PRODUCT_CODE
            this.quote.schedule_code = this.selectedQuote.RISK_USAGES
            this.quote.duration_type = this.selectedQuote.DURATION_TYPE == 'annual' ? 'annual' : (this.selectedQuote.DURATION_TYPE == 'shortrate' ? 'shortrate' : 'prorata')
            this.quote.quote_days = this.selectedQuote.QUOTE_DAYS
          }
        })
    else
      this.service.swalAlart.fire({
        text: "Premium computations for this policy will be treated as a new business.\nDo you wish to proceed?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: `Yes,Proceed`,
        reverseButtons: true
      })
        .then((dialogResponse) => {
          if (dialogResponse.hasOwnProperty('value') && dialogResponse.value == true) {
            this.quote.edit_mode = false;
            this.renewal = false;
          }
        })
  }

  //open search customer dialog
  /* openSearchCustomerDialog(){
    const dialogRef = this.dialog.open(SearchMotoQuoteCustomerComponent, {
      width: '600px',
      data: { selectedCustomer: this.selectedCustomer,isNewCustomer: this.isNewCustomer }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.hasOwnProperty('data')){
        this.selectedCustomer = result.data;

        if(this.selectedCustomer.isNewCustomer)
           this.openCustomerCreationDialog();
        else{
          if(this.selectedCustomer){

            this.quote.customer_code=this.selectedCustomer.CLIENT_CODE;
            //this.payload.customer_code=this.quote.customer_code;

            this.quote.customer_first_name=this.selectedCustomer.CLIENT_FIRST_NAME;
            this.quote.customer_last_name=this.selectedCustomer.CLIENT_FAMILY_NAME;
            this.quote.customer_email=this.selectedCustomer.CLIENT_HOME_EMAIL;
            this.quote.customer_phone=this.selectedCustomer.CLIENT_HOME_MOBILE;
            this.quote.customer_phone=this.selectedCustomer.CLIENT_HOME_MOBILE;

            this.quote.date_of_birth=this.selectedCustomer.CLIENT_DATE_OF_BIRTH;
            this.validateForm();
          }
       }

      }

    });
  }
 */


  /**
   * Show a styled confirmation dialog before proceeding to approve/pay.
   * Displays the payable amount and warns that approval pushes to NIC/MID.
   */
  confirmApprovePolicy() {
    const formattedAmount = this.currencyPipe.transform(this.payableAmount, this.quote.currency_code, 'symbol', '1.2-2') || '0.00';
    const paymentMode = this.paymentOption === 'installment' ? 'Installment (Upfront Payment)' : 'Full Payment';
    const policyNo = this.quote.policy_sequence || '—';
    const customerName = `${this.quote.customer_first_name || ''} ${this.quote.customer_last_name || ''}`.trim() || '—';

    this.service.swalAlart.fire({
      title: '',
      html: `
        <div style="text-align:center; padding: 8px 0 0;">
          <!-- Shield / check icon -->
          <div style="
            width: 64px; height: 64px; margin: 0 auto 18px;
            background: linear-gradient(135deg, #6B2D8B 0%, #A62B81 100%);
            border-radius: 50%;
            display: flex; align-items: center; justify-content: center;
            box-shadow: 0 4px 20px rgba(107, 45, 139, 0.3);
          ">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              <path d="M9 12l2 2 4-4"/>
            </svg>
          </div>

          <h2 style="
            font-family: 'gotham', sans-serif;
            font-size: 20px; font-weight: 700;
            color: #1a1a2e; margin: 0 0 6px;
          ">Confirm Policy Approval</h2>

          <p style="
            font-family: 'gotham', sans-serif;
            font-size: 13px; color: #6b7280;
            margin: 0 0 20px; line-height: 1.5;
          ">Please review the details below before proceeding.</p>

          <!-- Amount card -->
          <div style="
            background: linear-gradient(135deg, rgba(107,45,139,0.06) 0%, rgba(166,43,129,0.06) 100%);
            border: 1px solid #ede4f5;
            border-radius: 12px; padding: 18px 20px; margin-bottom: 16px;
          ">
            <div style="
              font-family: 'gotham', sans-serif;
              font-size: 11px; font-weight: 600;
              color: #6b7280; text-transform: uppercase;
              letter-spacing: 0.5px; margin-bottom: 6px;
            ">Amount to be Approved</div>
            <div style="
              font-family: 'gotham', sans-serif;
              font-size: 28px; font-weight: 800;
              color: #6B2D8B; letter-spacing: 0.3px;
            ">${formattedAmount}</div>
            <div style="
              font-family: 'gotham', sans-serif;
              font-size: 11px; color: #9ca3af;
              margin-top: 4px;
            ">${paymentMode}</div>
          </div>

          <!-- Details grid -->
          <div style="
            display: grid; grid-template-columns: 1fr 1fr;
            gap: 8px; margin-bottom: 18px; text-align: left;
          ">
            <div style="
              background: #faf8fd; border-radius: 8px; padding: 10px 12px;
            ">
              <div style="font-family:'gotham',sans-serif; font-size:10px; color:#9ca3af; text-transform:uppercase; letter-spacing:0.4px; margin-bottom:3px;">Policy No.</div>
              <div style="font-family:'gotham',sans-serif; font-size:13px; font-weight:600; color:#374151;">${policyNo}</div>
            </div>
            <div style="
              background: #faf8fd; border-radius: 8px; padding: 10px 12px;
            ">
              <div style="font-family:'gotham',sans-serif; font-size:10px; color:#9ca3af; text-transform:uppercase; letter-spacing:0.4px; margin-bottom:3px;">Customer</div>
              <div style="font-family:'gotham',sans-serif; font-size:13px; font-weight:600; color:#374151;">${customerName}</div>
            </div>
          </div>

          <!-- NIC/MID warning banner -->
          <div style="
            display: flex; align-items: flex-start; gap: 10px;
            background: #FFF7ED; border: 1px solid #FED7AA;
            border-radius: 10px; padding: 12px 14px;
            text-align: left;
          ">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#F59E0B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0; margin-top:1px;">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
            <div>
              <div style="font-family:'gotham',sans-serif; font-size:12px; font-weight:700; color:#92400E; margin-bottom:3px;">Important Notice</div>
              <div style="font-family:'gotham',sans-serif; font-size:11.5px; color:#B45309; line-height:1.45;">
                Approving this policy will automatically push the vehicle data to the <strong>NIC/MID</strong> (National Insurance Commission Motor Insurance Database). This action cannot be undone.
              </div>
            </div>
          </div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: 'Yes, Approve Policy',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
      focusCancel: true,
      customClass: {
        popup: 'swal-approve-popup',
        confirmButton: 'swal-approve-confirm-btn',
        cancelButton: 'swal-approve-cancel-btn',
      },
      buttonsStyling: true,
      confirmButtonColor: '#6B2D8B',
      cancelButtonColor: '#E5E7EB',
      width: 440,
      padding: '24px 28px 20px',
      allowOutsideClick: false,
    }).then((result) => {
      if (result.hasOwnProperty('value') && result.value === true) {
        // Run QuoteLevelEdit then immediately process as Cash
        this.approvePolicyCash();
      }
    });
  }

  /**
   * Runs the QuoteLevelEdit API call then, on success, fires the cash
   * payment API directly — identical to CashPaymentComponent.onSubmit().
   * A single continuous SweetAlert2 loading overlay covers both steps to
   * prevent any UI flicker between the two sequential API calls.
   */
  approvePolicyCash() {
    this.processing = true;

    // ── Prepare quote payload ─────────────────────────────────────────────
    const prepared_by = `${this.appuser.first_name || ''} ${this.appuser.last_name || ''}`.trim();

    this.quote.prepared_by = prepared_by;
    this.quote.policy_branch = this.appuser.agency || '1';
    this.quote.policy_office = this.appuser.agency || '1';
    this.quote.fleet = true;
    this.quote.module = this.appuser.role.toLowerCase();

    this.quote.customer_date_of_birth = moment(this.quote.customer_date_of_birth).format('DD/MM/YYYY');
    this.quote.inception_date = moment(this.quote.inception_date).format('DD/MM/YYYY');
    this.quote.expiry_date = moment(this.quote.expiry_date).format('DD/MM/YYYY');

    this.quote.client_code = this.quote.client_code;
    this.quote.policy_lob = '20';
    this.quote.platform = 'Webapp';
    this.quote.date_created = '';
    this.quote.updated = '';

    delete this.quote.quote_objects;

    if (this.appuser.role === 'AGENT') {
      this.quote = { ...this.quote, agent_code: this.appuser.code.toString(), client_code: this.quote.client_code.toString(), broker_user_code: '' };
    } else if (this.appuser.role === 'CLIENT') {
      this.quote = { ...this.quote, agent_code: '', client_code: this.appuser.code.toString(), broker_user_code: '' };
    } else if (this.appuser.role === 'BROKER_USER') {
      this.quote = { ...this.quote, agent_code: this.appuser.broker_user_main_broker_code.toString(), client_code: this.quote.client_code.toString(), broker_user_code: this.appuser.code.toString() };
    } else {
      // ADMIN / STAFF or any other role — use appuser.code as the agent_code
      this.quote = { ...this.quote, agent_code: this.appuser.code ? this.appuser.code.toString() : '', client_code: this.quote.client_code.toString(), broker_user_code: '' };
    }

    // Helper: reset processing flag and restore quote dates to DB format
    const resetState = () => {
      this.processing = false;
      this.populateQuoteValues();
    };

    // Helper: show a terminal error and reset state
    const showError = (title: string, text: string) => {
      this.processing = false;
      this.service.swalAlart.close();
      this.service.swalAlart.fire({ title: title, text: text, icon: 'error', allowOutsideClick: false, allowEscapeKey: false });
    };

    // ── Step 1: open a single loader that stays open across both API calls ─
    // In Swal v9 there is no didOpen — call showLoading() synchronously after fire().
    this.service.swalAlart.fire({
      title: 'Saving quote...',
      text: 'Please wait while we update your policy.',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
    });
    this.service.swalAlart.showLoading();

    const editPayload = { ...this.quote, quote_activity: 'QuoteLevelEdit' };

    this.service.editVehicle(editPayload)
      .toPromise()
      .then((editResponse: any) => {
        this.responseCode = editResponse.responseCode;
        this.responseMessage = editResponse.responseMessage;

        if (editResponse.responseCode !== '000') {
          // Edit failed — show error, restore state
          showError('Failed', this.responseMessage || 'Could not save quote. Please try again.');
          return;
        }

        // ── Step 2: keep the same loader running — no close/reopen flicker ─
        // Swal v9 has no getTitle()/getContent(); showLoading() is already
        // active so this is a no-op that simply keeps the overlay visible.
        this.service.swalAlart.showLoading();

        // Build cash payload (mirrors CashPaymentComponent exactly)
        let cashPayload: any = {
          module: 'agent',
          agent_code: this.quote.agent_code || '',
          broker_user_code: '',
          policy_sequence: this.quote.policy_sequence,
          transaction_type: 'Cash',
          status_of_client: this.quote.status_of_client || 'new',
          policy_lob: '20',
          platform: 'webapp'
        };

        if (this.appuser.role === 'AGENT' || this.appuser.role === 'BROKER_ADMIN') {
          cashPayload = { ...cashPayload, module: 'agent', agent_code: this.quote.agent_code, broker_user_code: '' };
        } else if (this.appuser.role === 'BROKER_USER') {
          cashPayload = { ...cashPayload, module: 'broker-user', agent_code: this.appuser.broker_user_main_broker_code, broker_user_code: this.appuser.code };
        } else if (this.appuser.role === 'CLIENT') {
          cashPayload = { ...cashPayload, module: 'client', agent_code: '', broker_user_code: '' };
        }

        // ── Step 3: call /transactions/motor/cash ─────────────────────────
        this.service.subPayment(cashPayload)
          .toPromise()
          .then((payResponse: any) => {
            this.responseCode = payResponse.responseCode;
            this.responseMessage = payResponse.responseMessage;

            if (payResponse.hasOwnProperty('responseCode') && payResponse.responseCode === '000') {
              this.processing = false;
              this.quote.module = 'PAID';
              this.service.swalAlart.fire({
                title: 'Payment successful',
                html: `SMS and email sent with policy details to print<br><br>` +
                  `<a target='_blank' href='${payResponse.stickerUrl}'>Click here to print sticker now</a><br><br>`,
                icon: 'success',
                confirmButtonText: 'Done',
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false
              }).then(() => {
                this.router.navigate(['transactions']);
              });

            } else if (payResponse.hasOwnProperty('responseCode') && payResponse.responseCode === '001') {
              this.processing = false;
              this.quote.module = 'PAID';
              this.service.swalAlart.fire({
                title: 'Processing payment...',
                html: 'Please wait. An SMS and email of policy and sticker details will be sent to you after processing payment.',
                icon: 'success',
                confirmButtonText: 'Done',
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false
              }).then(() => {
                this.router.navigate(['transactions']);
              });

            } else if (payResponse.responseCode === 'E31') {
              showError('Failed', 'Vehicle information already exists under a policy. Please check vehicle registration number and try again.');
              resetState();

            } else if (payResponse.responseCode === 'E23') {
              showError('Failed', 'Invoice Already Paid');
              resetState();

            } else if (payResponse.responseCode === 'E01' || payResponse.responseCode === 'E64') {
              showError('Failed', this.responseMessage);
              resetState();

            } else {
              const midErrors = payResponse.responseCode === '400 BAD_REQUEST' ? JSON.parse(payResponse.responseMessage) : null;
              showError('Failed', midErrors && midErrors.errors && midErrors.errors.length > 0 ? 'MID::' + midErrors.errors[0] : 'Payment failed!');
              resetState();
            }
          })
          .catch(() => {
            showError('Failed', 'A network error occurred during payment. Please try again.');
            resetState();
          });
      })
      .catch((error: any) => {
        const errTitle = (error && error.error && error.error.responseMessage) ? error.error.responseMessage : 'Server Error';
        const errText = (error && error.error && error.error.errorResponse) ? error.error.errorResponse : (this.responseMessage || 'An unexpected error occurred.');
        showError(errTitle, errText);
        // Don't call resetState() here — dates were already formatted so
        // just flip the flag; populateQuoteValues would double-convert them.
        this.processing = false;
      });
  }





  choosePaymentMethod() {

    //save quote level details for payment
    this.processing = true;
    let prepared_by = `${this.appuser.first_name ? this.appuser.first_name : ''} ${this.appuser.last_name ? this.appuser.last_name : ''}`.trim();

    this.quote.prepared_by = prepared_by
    this.quote.policy_branch = this.appuser.agency || '1'
    this.quote.policy_office = this.appuser.agency || '1'
    this.quote.fleet = true
    this.quote.module = this.appuser.role.toLowerCase(),
      // this.quote.status_of_client = (this.renewal_checked == 'renew' ? 'renew' : 'new'),

      console.log("post inception_date>>> " + this.quote.inception_date)
    console.log("post expiry date>>>>> " + this.quote.expiry_date)

    this.quote.customer_date_of_birth = moment(this.quote.customer_date_of_birth).format('DD/MM/YYYY'),
      this.quote.inception_date = moment(this.quote.inception_date).format('DD/MM/YYYY'),
      this.quote.expiry_date = moment(this.quote.expiry_date).format('DD/MM/YYYY'),


      this.quote.client_code = this.quote.client_code,
      this.quote.policy_lob = "20",
      this.quote.platform = "Webapp"

    this.quote.date_created = ""
    this.quote.updated = ""

    delete this.quote.quote_objects


    if (this.appuser.role == 'AGENT') {
      this.quote = {
        ...this.quote,
        agent_code: this.appuser.code.toString(),
        client_code: this.quote.client_code.toString(),
        broker_user_code: '',
      }
    }
    else if (this.appuser.role == 'CLIENT') {
      this.quote = {
        ...this.quote,
        agent_code: '',
        client_code: this.appuser.code.toString(),
        broker_user_code: '',
      }
    } else if (this.appuser.role == 'BROKER_USER') {
      this.quote = {
        ...this.quote,
        agent_code: this.appuser.broker_user_main_broker_code.toString(),
        client_code: this.quote.client_code.toString(),
        broker_user_code: this.appuser.code.toString(),
      }
    }

    //connect to api
    this.quoteLevelEdit(this.quote)

  }

  //confirm login pin to continue
  confirmPin() {
    let currentUser = this.service.currentUser();
    if (currentUser.role == "broker-user") {
      this.loginAsBrokerUser()
    } else {
      this.loginAsAgentClient()
    }
  }

  loginAsAgentClient() {
    this.service.swalAlart.fire({
      //title: "Identity Confirmation",
      icon: "warning",
      allowOutsideClick: false,
      showCancelButton: true,
      inputPlaceholder: "Confirm your Pin",
      input: "password",
      reverseButtons: true
    })
      .then((result: SweetAlertResult) => {
        if (result.value) {
          let currentUser = this.service.currentUser();
          //prepare payload
          let loginPayload = {};
          if (currentUser.role == "client") {
            loginPayload = {
              phone: currentUser.phone,
              pin: result.value,
              module: 'client'
            }

          } else if (currentUser.role == "agent") {
            loginPayload = {
              agent_code: currentUser.code,
              pin: result.value,
              module: 'agent'
            }

          } else { }

          swal.showLoading()
          this.service.webLogin(loginPayload)
            .toPromise()
            .then((responseData: any) => {
              swal.hideLoading()
              if (responseData.hasOwnProperty('responseCode') && responseData.responseCode === '000') {
                if (this.selectedMethod == 'Mobile')
                  this.openMomoPaymentDialog();
                else if (this.selectedMethod == 'Cash')
                  this.openCashPaymentDialog();
                else if (this.selectedMethod == 'Cheque')
                  this.openChequePaymentDialog();
                else if (this.selectedMethod == 'Card')
                  this.openCardPaymentDialog();
              }
              else {
                swal.fire({
                  title: 'Wrong credentials!',
                  text: 'Please check and try again',
                  icon: 'error',
                });
                setTimeout(() => { this.confirmPin() }, 2000);
              }

            }).catch(error => {
              swal.fire({
                title: 'Connection Failed!',
                text: 'Login Failed',
                icon: 'error',
              });
              setTimeout(() => { this.confirmPin() }, 2000);
            })
        }
        else
          this.alertSnackBar('No Pin was entered', 'User Not Verified');
      });

  }


  loginAsBrokerUser() {
    this.service.swalAlart.fire({
      //title: "Identity Confirmation",
      icon: "warning",
      allowOutsideClick: false,
      showCancelButton: true,
      inputPlaceholder: "Confirm your Pin",
      input: "password",
      reverseButtons: true
    })
      .then((result: SweetAlertResult) => {
        if (result.value) {
          let currentUser = this.service.currentUser();
          //prepare payload
          let loginPayload = {};
          loginPayload = {
            broker_user_code: currentUser.code,
            broker_user_pin: result.value,
            module: 'broker-user'
          }

          swal.showLoading()
          this.service.webLoginAsBrokerUser(loginPayload)
            .toPromise()
            .then((responseData: any) => {
              swal.hideLoading()
              if (responseData.hasOwnProperty('responseCode') && responseData.responseCode === '000') {
                if (this.selectedMethod == 'Mobile')
                  this.openMomoPaymentDialog();
                else if (this.selectedMethod == 'Cash')
                  this.openCashPaymentDialog();
                else if (this.selectedMethod == 'Cheque')
                  this.openChequePaymentDialog();
                else if (this.selectedMethod == 'Card')
                  this.openCardPaymentDialog();
              }
              else {
                swal.fire({
                  title: 'Wrong credentials!',
                  text: 'Please check and try again',
                  icon: 'error',
                });
                setTimeout(() => { this.confirmPin() }, 2000);
              }

            }).catch(error => {
              swal.fire({
                title: 'Connection Failed!',
                text: 'Login Failed',
                icon: 'error',
              });
              setTimeout(() => { this.confirmPin() }, 2000);
            })
        }
        else
          this.alertSnackBar('No Pin was entered', 'User Not Verified');
      });
  }


  //open momo Payment Dialog
  openMomoPaymentDialog() {
    const dialogRef = this.dialog.open(MomoPaymentComponent, {
      disableClose: true,
      width: '350px',
      data: { quotePayload: this.quote, total_premium: this.quote.total_premium_cv, policy_lob: "20" }
    });
  }


  //open card Payment Dialog
  openCardPaymentDialog() {
    const dialogRef = this.dialog.open(DebitCardPaymentComponent, {
      disableClose: true,
      width: '350px',
      data: { quotePayload: this.quote, total_premium: this.quote.total_premium_cv, policy_lob: "20" }
    });

    // dialogRef.afterClosed().subscribe(result => {

    //   if (result.hasOwnProperty('data')) {
    //     this.confirmedQuote = result.data.quotePayload.module == 'PAID';

    //     if (this.confirmedQuote) {
    //       setTimeout(() => {
    //         this.router.navigate(['transactions']);
    //       }, 3000)
    //     }
    //   }

    // });
  }

  //open cash Payment Dialog
  openCashPaymentDialog() {
    const dialogRef = this.dialog.open(CashPaymentComponent, {
      disableClose: true,
      width: '350px',
      data: { quotePayload: this.quote, total_premium: this.quote.total_premium_cv, policy_lob: "20" }
    });
    // dialogRef.afterClosed().subscribe(result => {

    //   if (result.hasOwnProperty('data')) {
    //     this.confirmedQuote = result.data.quotePayload.module == 'PAID';
    //     this.validateForm();

    //     if (this.confirmedQuote) {
    //       setTimeout(() => {
    //         this.router.navigate(['transactions']);
    //       }, 3000)
    //     }
    //   }

    // });
  }
  //open Cheque Payment Dialog
  openChequePaymentDialog() {
    const dialogRef = this.dialog.open(ChequePaymentComponent, {
      disableClose: true,
      width: '600px',
      data: { quotePayload: this.quote, total_premium: this.quote.total_premium_cv, policy_lob: "20" }
    });

    // dialogRef.afterClosed().subscribe(result => {
    //   if (result.hasOwnProperty('data')) {
    //     this.confirmedQuote = result.data.quotePayload.module == 'PAID';
    //     this.validateForm();

    //     if (this.confirmedQuote) {
    //       setTimeout(() => {
    //         this.router.navigate(['transactions']);
    //       }, 3000)
    //     }
    //   }
    // });

  }

  //confirm quote
  confirmQuote() {
    let selectedRisk: any = this.scheduleData.filter((risk: scheduleType) => risk.tabledCode == this.payload.risk);

    if (selectedRisk)
      selectedRisk = selectedRisk[0];

    let summary = {
      CLIENT_CODE: this.payload.client_code,
      INCEPTION_DATE: moment(this.quote.inception_date).format('DD/MM/YYYY'),
      EXPIRY_DATE: moment(this.quote.expiry_date).format('DD/MM/YYYY'),
      DATE_COMPLETED: moment().format('DD/MM/YYYY'),
      PREPARED_BY: this.payload.prepared_by,
      CUSTOMER_FIRST_NAME: this.payload.customer_first_name,
      CUSTOMER_LAST_NAME: this.payload.customer_last_name,
      CUSTOMER_EMAIL: this.payload.customer_email,
      CUSTOMER_PHONE: this.payload.customer_phone,
      YEAR_OF_MANUFACTURE: this.payload.year_of_manufacture,
      VEHICLE_REGISTRATION: this.payload.vehicle_registration,
      MAKE: this.payload.make,
      QUOTE_MODEL: this.payload.model,
      CUBIC_CAPACITY: this.payload.cubic_capacity,
      SUM_INSURED: this.payload.sum_insured,
      QUOTE_DAYS: (this.payload.duration_type == 'shortrate' ? this.payload.days : this.payload.days),
      DURATION_TYPE: this.payload.duration_type,
      EXCESS_TYPE_CODE: this.payload.excess_type_code,
      CURRENCY_CODE: this.payload.currency_code,
      RISK_DESCRIPTION: selectedRisk ? selectedRisk.tabledDesignation : null,
      COST_OF_INSURANCE: this.quote.total_premium,
      TPPD_LIMIT: this.quote.tppd_value,
      MONTHS: this.payload.months ? this.payload.months : 1,
      PRODUCT_CODE: this.payload.product,
      INPUTTED_DISCOUNT: this.payload.inputted_discount,
      EXTRA_PA: this.quote.pa_value
    }

    const dialogRef = this.dialog.open(QuoteSummaryComponent, {
      disableClose: true,
      width: '500px',
      data: {
        flow: 'moto',
        hide_foreign_currency: 0,
        quote: summary,
        total_premium: this.quote.total_premium,
        foreign_currency: this.quote.foreign_currency,
        foreign_amount: this.quote.foreign_amount,
        confirmedQuote: true
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.hasOwnProperty('data')) {
        this.confirmedQuote = result.data.confirmedQuote;
        this.choosePaymentMethod();
        this.validateForm();
      }
    });
  }





  onDaysChanged(days: number) {
    //days=!isNaN(+`${this.quote.days}`)?parseInt(this.quote.days):1;

    console.log("onDaysChanged>>>" + days)

    if (days >= 365) {
      days = 364;
      this.quote.quote_days = "365";
      this.quote.duration_type = "annual";

      this.daysTextFieldInput = "365";
      this.annual = true;

      console.log('Days changed is annual', days);

    } else {
      this.quote.duration_type = "shortrate";

      if (localStorage.getItem("motor-quote")) {
        this.daysTextFieldInput = days + 0
        this.annual = false

        this.quote.quote_days = this.daysTextFieldInput

      }


      console.log('Days changed is shortrate', days);
    }


    //restrict negative days
    if (days <= 0)
      this.quote.quote_days = '1';



    if (this.quote.inception_date) {
      let inception_date = this.quote.inception_date ? moment(this.quote.inception_date) : null;
      let expiry_date = moment(inception_date).add(days - 1, 'days').format('YYYY-MM-DD'); //minus 1 to days
      this.quote.expiry_date = expiry_date;
    }




  }








  /*=== //handle Access changes==*/
  transformAmount(element) {
    this.formattedAmount = this.currencyPipe.transform(this.formattedAmount, 'GHS ');
    element.target.value = this.formattedAmount;
  }

  onDaysInput(event) {

    let days = !isNaN(+`${event.target.value}`) ? parseInt(event.target.value) : 0;

    if (!days) {
      event.target.value = 1;
    }
    else if (days > 365)
      event.target.value = 365;

  }


  onBackClicked() {
    if (this.previousPram == "quotes") {
      this.router.navigate(["/quotes"])

    } else if (this.previousPram == "policies") {
      this.router.navigate(["/mypolicies"])

    } else if (this.previousPram == "renewals") {
      this.router.navigate(["/renewpolicy"])

    } else if (this.previousPram == "documents" || localStorage.getItem("quote_activity") == 'info_for_print') {
      this.router.navigate(["/policydocuments"])
    }
    else {
      this.router.navigate(["/products"])
    }

  }

  //http requests
  showSchedulesAndRisks() {
    this.service.getSchedulesAndRisks()
      .toPromise()
      .then((response: scheduleTypeResponse) => {
        if (response.responseCode == '000') {
          this.scheduleData = [];
          response.data.risks.map((schedule: any) => {
            this.scheduleData.push({ ...schedule, tabledCode: schedule.tabledCode.toString(), HIDE: false });
          })
        }
      }).catch(err => {
        //console.log('Schedules load error',err);
      });
  }

  //open customer creation
  openCustomerCreationDialog() {
    const dialogRef = this.dialog.open(CreateCustomerComponent, {
      disableClose: true,
      width: '800px',
      data: { newCustomerDetails: {} }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed', JSON.stringify(result));

      if (result.hasOwnProperty('data') && result.data.hasOwnProperty('customer_code'))
        this.quote = {
          ...this.quote,
          client_code: result.data.customer_code,
          type: result.data.type,
          customer_first_name: result.data.customer_first_name,
          customer_other_names: result.data.customer_other_names,
          customer_last_name: result.data.customer_last_name,
          customer_date_of_birth: moment(result.data.date_of_birth).format('YYYY-MM-DD'),
          customer_email: result.data.customer_email ? result.data.customer_email : '',
          customer_phone: result.data.customer_phone,
          digital_address: result.data.digital_address,
          id_type: result.data.id_type,
          customer_ghana_card_number: result.data.id_number,
          tin: result.data.tin
        }

      if (this.quote.type == '0')
        this.selectedCustomer.DISPLAY_SHORT_NAME = `${this.quote.customer_first_name},${this.quote.customer_last_name},${this.quote.customer_phone}`;
      else
        this.selectedCustomer.DISPLAY_SHORT_NAME = `${this.quote.customer_first_name},${this.quote.customer_phone}`;


    });
  }
  //http requests
  showCurrencies() {
    this.service.getCurrencies()
      .toPromise()
      .then((response: CurrencyResponse) => {
        if (response.responseCode == '000' && response.data && response.data.currencies) {
          response.data.currencies.map((currency: Currency) => {
            this.currencyData.push(currency);
          })
        }
      })
      .then(() => {
        this.onCurrencySelected(this.quote.currency_code);
      })
      .catch(err => {
        //console.log('Currencies load error',err);
      });
  }

  showBodyTypes() {
    this.service.getBodyTypes()
      .toPromise()
      .then((response: BodyTypeResponse) => {
        if (response.responseCode == '000') {
          this.bodyData = [];
          response.data.bodyTypes.map((body: BodyType) => {
            this.bodyData.push(body);
          })
        }
      }).catch(err => {
        //console.log('Body Type load error',err);
      });
  }

  showColors() {
    this.service.getColors()
      .toPromise()
      .then((response: colorResponse) => {
        if (response.responseCode == '000') {
          this.loadedColors = response.data.colors.map((c: Color) => ({
            ...c,
            DISPLAY_SHORT_NAME: c.tabledDesignation
          }));
          this.filteredColors = this.loadedColors.slice();
        }
      }).catch(err => {
        //console.log('Color load error', err);
      });
  }

  //run validation
  validateForm(input?: any): boolean {
    let hasError = false;
    console.log("hasError---->" + this.quote.customer_phone)
    this.errors = {
      client_code: false,
      customer_phone: false,
      customer_ghana_card_number: false,
      date_of_birth: false,
      product: false,
      // schedule_code: false,
      inception_date: false,
      expiry_date: false,
      currency_code: false,
      customer_email: false
    }
    if (!this.quote.client_code) {
      hasError = true;
      this.errors = { ...this.errors, client_code: true };
      console.log("client_code---->" + hasError)
    }
    if (this.quote.customer_phone.trim().length == 0 || this.quote.customer_phone && !this.service.validatePhone(this.quote.customer_phone)) {
      hasError = true;
      this.errors = { ...this.errors, customer_phone: true };
      console.log("customer_phone---->" + hasError)
    }
    if (this.quote.customer_ghana_card_number.trim().length == 0 || this.quote.customer_ghana_card_number && !this.service.validateGhanaCard(this.quote.customer_ghana_card_number)) {
      hasError = true;
      this.errors = { ...this.errors, customer_ghana_card_number: true };
      console.log("customer_ghana_card_number---->" + hasError)
    }
    if (this.quote.currency_code.trim().length == 0) {
      hasError = true;
      this.errors = { ...this.errors, currency_code: true };
      console.log("currency_code---->" + hasError)
    }

    // Email validation - required field with proper format
    if (!this.quote.customer_email || this.quote.customer_email.trim().length == 0) {
      hasError = true;
      this.errors = { ...this.errors, customer_email: true };
      console.log("customer_email required---->" + hasError)
    } else if (!this.service.validateEmail(this.quote.customer_email)) {
      hasError = true;
      this.errors = { ...this.errors, customer_email: true };
      console.log("customer_email invalid format---->" + hasError)
    }

    if (!(moment(this.quote.customer_date_of_birth).isValid() && moment(moment().format('YYYY-MM-DD')).diff(moment(this.quote.customer_date_of_birth).format('YYYY-MM-DD'), 'years') >= 18)) {
      hasError = true;
      this.errors = { ...this.errors, customer_date_of_birth: true };

      this.alertSnackBar(`Date of birth must be greater or equal to:${moment(this.dobStartAt).format('LL')}`, 'Invalid Date');
    }

    if (!this.quote.product) {
      hasError = true;
      this.errors = { ...this.errors, product: true };
      console.log("product---->" + hasError)
    }

    // if (!this.quote.schedule_code) {
    //   hasError = true;
    //   this.errors = { ...this.errors, schedule_code: true };
    //   console.log("schedule_code---->" + hasError)
    // }

    if (!moment(this.quote.inception_date).isValid()) {
      hasError = true;
      this.errors = { ...this.errors, inception_date: true };
      console.log("inception_date---->" + hasError)
    }

    if (!moment(this.quote.expiry_date).isValid()) {
      hasError = true;
      this.errors = { ...this.errors, expiry_date: true };
      console.log("expiry_date---->" + hasError)
    }

    return hasError;

  }


  finalizeQuote = (policy_no) => {
    // console.log('gen_comments>>>>> ' +  this.quote.gen_comments)

    //finalizing the quote creation
    this.payload = {
      gen_comments: this.quote.gen_comments,
      prepared_by: this.payload.prepared_by,
      policy_sequence: policy_no,
      platform: "Webapp",
      module: this.appuser.role,
      status_of_client: this.renewal ? 'renew' : "new",
      vehicle_registration: this.quote.vehicle_registration,
      make: this.selectedMake.VEHICLE_MAKE_DESC,
      model: this.selectedModel.VEHICLE_MODEL_DESC,
      chasis_number: this.quote.chasis_number,
      year_of_manufacture: this.quote.year_of_manufacture.toString(),
      body_type_code: this.quote.body_type_code,
      seats_number: this.quote.seats.toString(),
      currency_code: this.quote.currency_code,
      cubic_capacity: this.quote.cubic_capacity.toString(),
      fleet: "",
      exchange_rate: parseFloat(this.quote.exchange_rate).toFixed(2).toString(),
      duration_type: "",
      sum_insured: this.quote.sum_insured.toString(),
      excess_type_code: (this.quote.excess_buy_back ? 'EIB' : 'ENA'),
      tppd_limit: this.quote.tppd_value ? this.quote.tppd_value : "0",
      legacy_policy_number: this.quote.legacy_policy_number,
      color: this.selectedColor.DISPLAY_SHORT_NAME,
      color_code: parseInt(this.selectedColor.tabledCode),
      customer_first_name: this.quote.customer_first_name,
      customer_last_name: this.quote.customer_last_name,
      customer_other_names: "",
      customer_email: this.quote.customer_email ? this.quote.customer_email : '',
      customer_phone: this.quote.customer_phone,
      customer_date_of_birth: moment(this.quote.date_of_birth).format('DD/MM/YYYY'),
      customer_branch_code: this.appuser.agency || '1',
      customer_type_code: this.quote.customer_type_code,
      additional_pa_amt: this.quote.pa_value ? this.quote.pa_value : "0",
      product: this.quote.product,
      risk: this.quote.schedule_code,
      fleet_number: "",
      age_added: this.quote.vehicle_age_loading ? '1' : '0',
      cc_added: this.quote.cc_loading ? '1' : '0',
      intermediary_number: "AGT-MAXk-0000022",
      intermediary_nic_registration_number: "NIC/MC/020",
      intermediary_first_name: this.appuser.first_name ? this.appuser.first_name : '',
      intermediary_last_name: this.appuser.last_name ? this.appuser.last_name : '',
      intermediary_other_names: "",
      intermediary_phone: this.appuser.phone,
      intermediary_email: this.appuser.email,
      intermediary_type_code: "04",
      intermediary_branch_code: this.appuser.agency || '1',
      ncd_discount_year: this.quote.ncd_value ? this.quote.ncd_value : "0",
      inception_date: moment(this.quote.inception_date).format('DD/MM/YYYY'),
      expiry_date: moment(this.quote.expiry_date).format('DD/MM/YYYY'),
      make_code: parseInt(this.selectedMake.VEHICLE_MAKE_CODE),
      model_code: parseInt(this.selectedModel.VEHICLE_MODEL_CODE),
      mileage: this.quote.mileage,
      policy_agency: this.appuser.agency || '1',
      inputted_discount: this.quote.inputted_discount,
      inputted_loading: this.quote.inputted_loading
    }


    if (this.appuser.role == 'AGENT') {
      this.payload = {
        ...this.payload,
        agent_code: this.appuser.code.toString(),
        client_code: this.quote.client_code.toString(),
        broker_user_code: '',
      }
    }
    else if (this.appuser.role == 'CLIENT') {
      this.payload = {
        ...this.payload,
        agent_code: '',
        client_code: this.appuser.code.toString(),
        broker_user_code: '',
      }
    } else if (this.appuser.role == 'BROKER_USER') {
      this.payload = {
        ...this.payload,
        agent_code: this.appuser.broker_user_main_broker_code.toString(),
        client_code: this.quote.client_code.toString(),
        broker_user_code: this.appuser.code.toString(),
      }
    }

    //pass lagacy values for renewals
    if (this.renewal)
      this.payload = {
        ...this.payload,
        legacy_policy_sequence: this.quote.legacy_policy_sequence,
        legacy_total_premium: this.quote.legacy_total_premium,
        legacy_tppd_limit: this.quote.legacy_tppd_limit,
        legacy_excess_type_code: this.quote.legacy_excess_type_code,
        legacy_cc_added: this.quote.legacy_cc_added,
        legacy_age_added: this.quote.legacy_age_added,
        legacy_additional_pa_amt: this.quote.legacy_additional_pa_amt
      }
    //end lagacy values for renewals
    if (this.quote.days_label.toLowerCase() == 'months' || this.quote.days_label.toLowerCase() == 'month(s)')
      this.payload = {
        ...this.payload,
        months: this.quote.quote_days
      }
    else
      this.payload = {
        ...this.payload,
        days: this.quote.quote_days
      }


    let selectedBody: any = this.bodyData.filter(r => r.tabledCode == this.quote.body_type_code);

    if (selectedBody)
      this.payload.body_type_description = selectedBody[0].tabledDesignation

    if (this.quote.duration_type == 'annual')
      this.payload.duration_type = 'annual';
    else if (this.quote.duration_type == 'shortrate')
      this.payload.duration_type = 'shortrate';
    else
      this.payload.duration_type = 'prorata';

    this.service.swalAlart.showLoading();
    this.service.submitMotoQuote(this.payload)
      .toPromise()
      .then((response: any) => {
        if (response['responseCode'] && response['responseCode'] == 'E54')
          this.service.swalAlart.fire({
            title: 'Error',
            text: 'Sorry, this policy is not due for renewal',
            icon: 'error',
          });
        else if (response.responseCode == 'E56')
          this.service.swalAlart.fire({
            title: 'Error',
            text: "Sorry, we couldn't find any branch associated with this account. Kindly contact your branch manager.",
            icon: 'error',
          });
        else if (response.responseCode == 'E57')
          this.service.swalAlart.fire({
            title: 'Error',
            text: "Sorry, you cannot renew policy at this branch,kindly contact your branch office",
            icon: 'error',
          });
        else {
          this.quote.total_premium = response.responseConvertedValue ? response.responseConvertedValue.toString().replace(",", "").trim() : '0';
          this.quote.foreign_currency = response.responseCurrencyValue;
          this.quote.foreign_amount = response.responseData.toString().replace(",", "").trim();
          this.confirmQuote();
          this.service.swalAlart.close();
          this.processing = false;
        }

      }).
      catch(error => {
        //console.log('submit error',error)
        this.processing = false;
        this.service.swalAlart.close()
        this.service.swalAlart.fire({
          title: 'Error',
          text: 'Server Error,retry later',
          icon: 'error',
        });
      })
  }

  dobFilter(date: Date) {
    return moment(moment().format('YYYY-MM-DD')).diff(moment(date).format('YYYY-MM-DD'), 'years') >= 18;
  };

  //trigger the snackbar
  alertSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  // ── Client search bar ────────────────────────────────────
  /**
   * Fired when the user clicks "Search" in the client search panel.
   * Calls GET /client?{searchBy}={value} and pre-fills the Customer Details form.
   */
  onSearchClient() {
    if (!this.clientSearchValue || !this.clientSearchValue.trim()) {
      this.clientSearchError = 'Please enter a search value.';
      return;
    }
    this.clientSearchError = '';
    this.isClientSearchLoading = true;

    this.clientService.searchClientBy(this.clientSearchBy, this.clientSearchValue.trim())
      .subscribe(
        (response) => {
          this.isClientSearchLoading = false;

          if (
            response &&
            response.responseCode === '000' &&
            response.data &&
            response.data.clients &&
            response.data.clients.length > 0
          ) {
            const client: Client = response.data.clients[0];

            // Populate quote customer fields
            this.quote.client_code = client.clientCode ? client.clientCode.toString() : '';
            this.quote.customer_first_name = client.otherNames || '';
            this.quote.customer_last_name = client.surname || '';
            this.quote.customer_email = client.email || '';
            this.quote.customer_phone = client.telephone || client.cellNumber || '';
            // API returns dateOfBirth as 'yyyy-MM-dd' — parse it directly into a
            // Date object so mat-datepicker can display it correctly.
            this.quote.customer_date_of_birth = client.dateOfBirth
              ? moment(client.dateOfBirth, 'YYYY-MM-DD').toDate()
              : '';
            this.quote.customer_ghana_card_number = client.ghCardNumber || '';

            // Sync FormControl values so validators/UI reflect changes
            this.customer_email.setValue(this.quote.customer_email);
            this.customer_phone.setValue(this.quote.customer_phone);
            this.customer_date_of_birth.setValue(this.quote.customer_date_of_birth);
            this.customer_ghana_card_number.setValue(this.quote.customer_ghana_card_number);

            this.clientSearchError = '';
          } else {
            // Clear customer fields if nothing found
            this.quote.client_code = '';
            this.quote.customer_first_name = '';
            this.quote.customer_last_name = '';
            this.quote.customer_email = '';
            this.quote.customer_phone = '';
            this.quote.customer_date_of_birth = '';
            this.quote.customer_ghana_card_number = '';

            this.clientSearchError = 'No client found. Please check the value and try again.';
          }
        },
        (err) => {
          this.isClientSearchLoading = false;
          this.clientSearchError = 'Search failed. Please try again.';
          console.error('[ClientSearch] Error:', err);
        }
      );
  }

  //autocomplete search customer
  onFilterCustomer() {
    this.searchCustomerCtrl.valueChanges
      .pipe(
        debounceTime(500),
        tap(() => {
          this.filteredCustomers = [];
          this.isCustomerLoading = true;
        }),
        switchMap(value => {
          if (value && value.length) {

            if (this.appuser.role == "agent") {
              this.filterClientPayload = {
                ...this.filterClientPayload,
                agent_code: this.appuser.code,
                search_parameter: value
              }

            } else if (this.appuser.role == "broker-user") {
              this.filterClientPayload = {
                ...this.filterClientPayload,
                broker_user_code: this.appuser.code,
                search_parameter: value
              }
            }

            console.log("filterClientPayload>>>>>>" + this.filterClientPayload)
            return this.service.searchCustomer(this.filterClientPayload)
              .pipe(
                finalize(() => {
                  this.isCustomerLoading = false
                }),
              )
          } else {
            this.isCustomerLoading = false
            return new Observable<[]>();
          }


        }
        )
      )
      .subscribe((response: CustomerResponse) => {
        if (response.hasOwnProperty('responseCode') && response.responseCode == '000') {
          response.profile.map(r => {

            r.CLIENT_DATE_OF_BIRTH = this.service.strDateToDBFormat(r.CLIENT_DATE_OF_BIRTH);

            let name_parts = [];
            if (r.CLIENT_FIRST_NAME)
              name_parts.push(r.CLIENT_FIRST_NAME);

            if (r.CLIENT_FAMILY_NAME)
              name_parts.push(r.CLIENT_FAMILY_NAME);

            if (r.CLIENT_HOME_MOBILE)
              name_parts.push(r.CLIENT_HOME_MOBILE);

            //if(r.CLIENT_CODE)
            //name_parts.push(`(${r.CLIENT_CODE})`);

            r.DISPLAY_NAME = name_parts.join(',');

            /*  let temp=name_parts[0];
             name_parts[0]=name_parts[name_parts.length-1];
             name_parts[name_parts.length-1]=temp;

             r.DISPLAY_SHORT_NAME=name_parts.slice(0,name_parts.length-1).join(','); */
            r.DISPLAY_SHORT_NAME = r.DISPLAY_NAME;

            r.isNewCustomer = false;


            this.filteredCustomers.push(r);
          })

        }
      });
  }

  //autocomplete search make
  onLoadMake() {
    this.filteredMakes = [];
    this.loadedMakes = [];

    this.service.searchMake(this.service.currentUser().role == 'agent' ? this.service.currentUser().code : '', '', this.service.currentUser().role == 'agent' ? '' : this.service.currentUser().code)
      .toPromise()
      .then((response: MakeResponse) => {
        if (response.hasOwnProperty('responseCode') && response.responseCode == '000') {
          response.responseData.map((response: Make) => {
            let make: Make = { ...response, DISPLAY_SHORT_NAME: `${response.VEHICLE_MAKE_DESC}` };
            this.loadedMakes.push(make);
            this.filteredMakes.push(make);
          })
        }
      });

  }
  onFilterMake() {
    this.searchMakeCtrl.valueChanges
      .pipe(
        debounceTime(0),
        tap(() => {
          this.filteredMakes = [];
          this.isMakeLoading = true;
        }),
        switchMap(value => {
          if (value.length) {
            return Observable.create(observer => {
              let payload = this.loadedMakes.filter((response: Make) => response.DISPLAY_SHORT_NAME.trim().toLowerCase().includes(value.trim().toLowerCase()) == true)
              observer.next(payload)
            })
              .pipe(
                finalize(() => {
                  this.isMakeLoading = false
                }),
              )
          }
          else {
            this.isMakeLoading = false
            return new Observable<[]>();
          }
        }
        )
      )
      .subscribe((models: any) => {
        if (models)
          models.map((response: Make) => {

            this.filteredMakes.push({ ...response, DISPLAY_SHORT_NAME: `${response.VEHICLE_MAKE_DESC}` });
          })
      })
  }
  //load models
  onLoadModel() {
    this.filteredModels = [];
    this.loadedModels = [];
    this.service.searchModel(this.service.currentUser().role == 'agent' ? this.service.currentUser().code : '', this.selectedMake.VEHICLE_MAKE_CODE, '', this.service.currentUser().role == 'agent' ? '' : this.service.currentUser().code)
      .toPromise()
      .then((response: any) => {
        if (response.hasOwnProperty('responseCode') && response.responseCode == '000') {
          response.responseData.map((model: Model) => {
            //console.log('loaded models',model)
            model.DISPLAY_SHORT_NAME = model.VEHICLE_MODEL_DESC;
            this.loadedModels.push(model);
            this.filteredModels.push({ ...model, DISPLAY_SHORT_NAME: `${model.VEHICLE_MODEL_DESC}` });

          });
        }
      })
  }
  //autocomplete search model
  onFilterModel() {
    this.searchModelCtrl.valueChanges
      .pipe(
        debounceTime(0),
        tap(() => {
          this.filteredModels = [];
          this.isModelLoading = true;
        }),
        switchMap((value: string) => {
          if (value) {

            return Observable.create(observer => {
              let payload = this.loadedModels.filter((response: Model) => response.DISPLAY_SHORT_NAME.trim().toLowerCase().includes(value.trim().toLowerCase()) == true)
              observer.next(payload)
            })
              .pipe(
                finalize(() => {
                  this.isModelLoading = false
                }),
              )
          }
          else {
            this.isModelLoading = false;
            this.filteredModels = this.filteredModels;
            return new Observable<[]>();
          }
        }
        )
      ).subscribe((models: any) => {
        if (models)
          models.map((response: Model) => {

            this.filteredModels.push({ ...response, DISPLAY_SHORT_NAME: `${response.VEHICLE_MODEL_DESC}` });
          })
      })
  }
  //autocomplete search color
  onFilterColor() {
    this.searchColorCtrl.valueChanges
      .pipe(
        debounceTime(200),
        tap(() => {
          this.isColorLoading = true;
        }),
        switchMap((value: any) => {
          if (value && typeof value === 'object') {
            this.isColorLoading = false;
            return new Observable<[]>();
          }
          if (value && value.length) {
            return Observable.create(observer => {
              const filtered = this.loadedColors.filter((c: Color) =>
                c.tabledDesignation.toLowerCase().includes(value.trim().toLowerCase())
              );
              observer.next(filtered);
            }).pipe(finalize(() => { this.isColorLoading = false; }));
          } else {
            this.isColorLoading = false;
            this.filteredColors = this.loadedColors.slice();
            return new Observable<[]>();
          }
        })
      )
      .subscribe((colors: any) => {
        if (colors)
          this.filteredColors = colors.map((c: Color) => ({ ...c, DISPLAY_SHORT_NAME: c.tabledDesignation }));
      });
  }

  //selected selected customer
  onSelectCustomer(customer: CustomerProfile) {
    this.errors = { ...this.errors, customer_code: false };

    this.selectedCustomer = customer;
    this.quote.client_code = this.selectedCustomer.CLIENT_CODE
    this.quote.customer_first_name = this.selectedCustomer.CLIENT_FIRST_NAME ? this.selectedCustomer.CLIENT_FIRST_NAME : this.selectedCustomer.CLIENT_FAMILY_NAME
    this.quote.customer_last_name = this.selectedCustomer.CLIENT_FAMILY_NAME
    this.quote.customer_phone = this.selectedCustomer.CLIENT_HOME_MOBILE
    this.quote.customer_email = (this.selectedCustomer.CLIENT_HOME_EMAIL ? this.selectedCustomer.CLIENT_HOME_EMAIL : '')
    this.quote.customer_date_of_birth = this.selectedCustomer.CLIENT_DATE_OF_BIRTH
    this.quote.customer_ghana_card_number = (this.selectedCustomer.CLIENT_GHANA_CARD_NUMBER ? this.selectedCustomer.CLIENT_GHANA_CARD_NUMBER : '')
    this.quote.customer_type_code = this.selectedCustomer.CLIENT_TYPE
  }
  //selected selected customer
  onSelectMake(make: Make) {
    //console.log('make selected',make)
    this.errors = { ...this.errors, make: false };

    this.selectedMake = make;
    this.quote.make_code = this.selectedMake.VEHICLE_MAKE_CODE
    this.quote.make = this.selectedMake.VEHICLE_MAKE_DESC

    this.onLoadModel()
  }

  //selected selected customer
  onSelectModel(model: Model) {
    //console.log('model selected',model)

    this.errors = { ...this.errors, model: false };

    this.selectedModel = model;
    this.quote.model_code = this.selectedModel.VEHICLE_MODEL_CODE
    this.quote.model = this.selectedModel.VEHICLE_MODEL_DESC
  }
  //selected selected color
  onSelectColor(color: Color) {
    this.errors = { ...this.errors, color: false };
    this.selectedColor = color;
    this.searchColorCtrl.setValue(color, { emitEvent: false });
    this.quote.color_code = this.selectedColor.tabledCode
    this.quote.color = this.selectedColor.tabledDesignation
  }

  //customer change event
  onCustomerChange(event) {
    if (!event.target.value) {
      this.selectedCustomer = {
        CLIENT_CODE: "",
        CLIENT_FAMILY_NAME: "",
        CLIENT_HOME_MOBILE: "",
        CLIENT_FIRST_NAME: "",
        CLIENT_HOME_EMAIL: "",
        CLIENT_DATE_OF_BIRTH: "",
        DISPLAY_NAME: "",
        DISPLAY_SHORT_NAME: "",
        isNewCustomer: false
      }

      this.quote.customer_first_name = this.selectedCustomer.CLIENT_FIRST_NAME
      this.quote.customer_last_name = this.selectedCustomer.CLIENT_FAMILY_NAME
      this.quote.customer_phone = this.selectedCustomer.CLIENT_HOME_MOBILE
      this.quote.customer_email = (this.selectedCustomer.CLIENT_HOME_EMAIL ? this.selectedCustomer.CLIENT_HOME_EMAIL : '')
      this.quote.customer_date_of_birth = this.selectedCustomer.CLIENT_DATE_OF_BIRTH

    }
  }

  //make change event
  onMakeChange(event) {
    if (!event.target.value) {
      this.selectedMake = {
        VEHICLE_MAKE_CODE: "",
        VEHICLE_MAKE_DESC: "",
        DISPLAY_SHORT_NAME: ""
      }
      this.quote.make_code = this.selectedMake.VEHICLE_MAKE_CODE
      this.quote.make = this.selectedMake.VEHICLE_MAKE_DESC
    }
    else
      this.filteredModels = [];
  }
  //make change event
  onModelChange(event) {
    if (!event.target.value) {
      this.selectedModel = {
        VEHICLE_MODEL_CODE: "",
        VEHICLE_MODEL_MAKE_CODE: "",
        VEHICLE_MODEL_DESC: "",
        VEHICLE_MODEL_SECOND_DESC: "",
        DISPLAY_SHORT_NAME: ""
      }
      this.quote.model_code = this.selectedModel.VEHICLE_MODEL_CODE
      this.quote.model = this.selectedModel.VEHICLE_MODEL_DESC
    }
    else
      this.filteredModels = [];
  }
  onModelClick(event) {
    if (!event.target.value)
      this.filteredModels = this.loadedModels;
  }

  //color change event
  onColorChange(event) {
    if (!event.target.value) {
      this.selectedColor = {
        tabledCode: "",
        tabledDesignation: "",
        DISPLAY_SHORT_NAME: ""
      }
      this.quote.color_code = this.selectedColor.tabledCode
      this.quote.color = this.selectedColor.tabledDesignation
    }
  }




  onUploadData() {
    const dialogRef = this.dialog.open(uploadExcelDataDialogComponent, {
      disableClose: false,
      width: '377px',
      data: { module: '' }
    });
    dialogRef.afterClosed().subscribe(result => {
    });

  }


  onAddVehicle() {
    console.log("onAddVehicle---->" + this.validateForm())
    if (this.validateForm()) {
      this.service.swalAlart.fire({
        title: 'Validation Alert',
        text: 'Kindly complete the highlighted fields',
        icon: 'warning',
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel',
        reverseButtons: true
      })

    } else {
      //save quote details to localstorage
      this.quote.inception_date = moment(this.quote.inception_date).format('DD/MM/YYYY')
      this.quote.expiry_date = moment(this.quote.expiry_date).format('DD/MM/YYYY')
      this.quote.customer_date_of_birth = moment(this.quote.customer_date_of_birth).format('DD/MM/YYYY')

      //init quote object params
      this.quote.quote_objects = [
        {
          objecth_sequence: null,
          objecth_id: null,
          vehicle_registration: "",
          make: "",
          make_code: null,
          quote_model: "",
          model_code: null,
          chasis_number: "",
          body_type_code: "",
          body_type_description: "",
          seats: null,
          year_of_manufacture: "",
          cubic_capacity: null,
          mileage: null,
          sum_insured: 0.00,
          sum_insured_rate: 0.00,
          sum_insured_rate_cv: 0.00,
          total_premium: 0.00,
          total_premium_cv: 0.00,
          color: "",
          color_code: "",
          risk: "",
          object_days: 365,
          object_months: null,
          inception_date: "",
          expiry_date: "",
          excess_amount: 0,
          excess_type_code: "ENA",
          legacy_excess_type_code: "ENA",
          tppd_limit: 0.00,
          tppd_rate: 0.00,
          legacy_tppd_limit: 0.00,
          additional_pa_amt: 0.00,
          additional_pa_charge: 0.00,
          legacy_additional_pa_amt: 0.00,
          personal_accident_charge: 0.00,
          additional_loading_amt: 0.00,
          additional_loading_rate: 0.00
        }
      ]



      localStorage.setItem('motor-quote', JSON.stringify(this.quote))
      localStorage.setItem('objecth_position', "0")
      localStorage.setItem('objecth_position', "0")

      localStorage.removeItem('motor-quote-edit')

      console.log("quote_activity: FleetMotorr===>" + localStorage.getItem("quote_activity"))

      if (localStorage.getItem("quote_activity") == 'new' || localStorage.getItem("quote_activity") == 'new_add') {
        localStorage.setItem('quote_activity', 'new_add')

      } else if (localStorage.getItem("quote_activity") == 'edit_add' || localStorage.getItem("quote_activity") == 'edit') {
        localStorage.setItem('quote_activity', 'edit_add')

      } else if (localStorage.getItem("quote_activity") == 'policy_renewals' || localStorage.getItem("quote_activity") == 'policy_renewals_edit') {
        localStorage.setItem('quote_activity', 'policy_renewals_edit_add')
      }

      this.router.navigate(["/fleet-motor-add-vehicle"])

    }


  }

  onDownloadTemplate() {
    console.log("Download excel template")
  }


  openQuoteSummaryDialog(objecth_position: any, objecth_id: any) {
    console.log('objecth_position>>>>>>>>', objecth_position)
    console.log('Vehicle Info', JSON.stringify(this.quote.quote_objects[objecth_position]))
    console.log('total_premium_cv', this.quote.quote_objects[objecth_position].total_premium_cv)
    console.log('Policy Info', this.quote)

    const dialogRef = this.dialog.open(QuoteSummaryFleetComponent, {
      disableClose: true,
      width: '500px',
      data: {
        flow: 'moto',
        hide_foreign_currency: 0,
        quote: this.quote.quote_objects[objecth_position],
        policyInfo: this.quote,

        total_premium: this.quote.quote_objects[objecth_position].total_premium_cv,
        foreign_currency: this.quote.currency_code,
        foreign_amount: this.quote.quote_objects[objecth_position].total_premium,
        confirmedQuote: false
      }
    });

    dialogRef.afterClosed().subscribe(result => { });

  }


  editQuoteSummaryDialog(objecth_position: string, objecth_id: string) {
    if (this.validateForm()) {
      this.service.swalAlart.fire({
        title: 'Validation Alert',
        text: 'Kindly complete the highlighted fields',
        icon: 'warning',
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel',
        reverseButtons: true
      })
    } else {
      //save quote details to localstorage
      this.quote.inception_date = moment(this.quote.inception_date).format('DD/MM/YYYY')
      this.quote.expiry_date = moment(this.quote.expiry_date).format('DD/MM/YYYY')
      this.quote.customer_date_of_birth = moment(this.quote.customer_date_of_birth).format('DD/MM/YYYY')


      console.log("objecth_position>>>>>" + objecth_position)
      console.log("objecth_id>>>>>" + objecth_id)

      localStorage.setItem('objecth_position', objecth_position)
      localStorage.setItem('objecth_id', objecth_id)
      //console.log("motor-quote-edit>>>>>" + JSON.stringify(selectedVehicle))

      localStorage.setItem('motor-quote', JSON.stringify(this.quote))

      console.log("quote_activity: Fleet Motor Edit>>>>" + localStorage.getItem("quote_activity"))

      if (localStorage.getItem("quote_activity") == 'new') {
        localStorage.setItem('quote_activity', 'new_edit')

      } else if (localStorage.getItem("quote_activity") == 'edit' || localStorage.getItem("quote_activity") == 'edit_add') {
        localStorage.setItem('quote_activity', 'edit')

      } else if (localStorage.getItem("quote_activity") == 'policy_renewals' || localStorage.getItem("quote_activity") == 'policy_renewals_edit_add') {
        localStorage.setItem('quote_activity', 'policy_renewals_edit')
      }

      this.router.navigate(['/fleet-motor-add-vehicle']);
      //this.router.navigate(['/fleet-motor-add-vehicle'],{state:{editableQuote:selectedVehicle}});
    }
  }


  deleteVehicleDialog(objecth_id: number) {
    this.service.swalAlart.fire({
      title: '',
      icon: 'info',
      text: 'Do you want to remove this vehicle?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No, thanks!',
      reverseButtons: true,
      allowOutsideClick: false,
      allowEscapeKey: false
    }).then((result) => {
      if (result.value) {

        console.log("objecth_id>>>>>" + objecth_id)

        this.deleteVehicle(this.quote, objecth_id)

      } else {
        result.dismiss === this.service.swalAlart.DismissReason.cancel

      }

    })
  }



  deleteVehicle(postPayload: any, objecth_id: number) {

    postPayload.quote_activity = "Delete"
    const deletedVehicleObject = this.quoteDetails[0].quote_objects.find((element: any) => element.objecth_id === objecth_id);
    postPayload.quote_objects = []
    postPayload.quote_objects.push(deletedVehicleObject)
    const matchedCoverDelete = this.coverData.find(c => c.viewValue === this.quote.product_description)
      || this.coverData.find(c => c.productCode === this.quote.product);
    postPayload.product_description = matchedCoverDelete ? matchedCoverDelete.viewValue : null;


    console.log("payload>>>>>" + JSON.stringify(postPayload))

    postPayload.customer_date_of_birth = moment(postPayload.customer_date_of_birth).format('DD/MM/YYYY'),
      postPayload.inception_date = moment(postPayload.inception_date).format('DD/MM/YYYY'),
      postPayload.expiry_date = moment(postPayload.expiry_date).format('DD/MM/YYYY'),


      this.service.swalAlart.showLoading()
    this.service.deleteVehicle(postPayload)
      .toPromise()
      .then((response: any) => {
        this.service.swalAlart.close()

        this.responseCode = response.responseCode
        this.responseMessage = response.responseMessage

        if (response.responseCode == '000') {
          this.loadQuoteVehicles()

          swal.fire({
            icon: 'success',
            text: 'Vehicle removed',
            timer: 5000,
            showConfirmButton: false
          });

        } else {
          this.service.swalAlart.fire({
            title: 'Failed',
            text: this.responseMessage,
            icon: 'error',
          });
        }

      }).catch(error => {
        //console.log('Error',error)
        this.processing = false;
        this.service.swalAlart.close();
        this.service.swalAlart.fire({
          title: 'Server Error',
          text: this.responseMessage,
          icon: 'error',
        });
      })

  }


  onSelectPolicy(policy) {
    this.selectedPolicy = policy;
  }

  onPrinkSticker() {
    let stickerURL = this.quote.quote_objects[this.selectedPolicy].sticker_link
    if (stickerURL) {
      window.open(stickerURL, '_blank')
    } else {
      this.service.swalAlart.fire({
        icon: "error",
        text: "No Sticker found",
        confirmButtonText: "Ok"
      })
    }
  }

  onPrinkCertificate() {
    let certificateURL = this.quote.quote_objects[this.selectedPolicy].certificate_link
    if (certificateURL) {
      window.open(certificateURL, '_blank')
    } else {
      this.service.swalAlart.fire({
        icon: "error",
        text: "No Certificate found",
        confirmButtonText: "Ok"
      })
    }
  }







  transactionStatus() {
    let payload: any = {}

    if (this.appuser.role == 'AGENT') {
      payload = {
        agent_code: this.appuser.code,
        client_code: this.quotePayloadBeforePayment.client_code,
        module: 'agent',
        transaction_token: this.quotePayloadBeforePayment.transactionToken,
        policy_sequence: this.quotePayloadBeforePayment.policy_sequence,
        platform: 'webapp',
        policy_lob: this.quotePayloadBeforePayment.policy_lob,
      }
    } else if (this.appuser.role == 'BROKER_USER') {
      payload = {
        agent_code: this.appuser.broker_user_main_broker_code,
        broker_user_code: this.appuser.code,
        client_code: this.quotePayloadBeforePayment.client_code,
        module: 'broker-user',
        transaction_token: this.quotePayloadBeforePayment.transactionToken,
        policy_sequence: this.quotePayloadBeforePayment.policy_sequence,
        platform: 'webapp',
        policy_lob: this.quotePayloadBeforePayment.policy_lob,

      }

    } else if (this.appuser.role == 'client') {
      payload = {
        client_code: this.appuser.code,
        module: 'client',
        transaction_token: this.quotePayloadBeforePayment.transactionToken,
        policy_sequence: this.quotePayloadBeforePayment.policy_sequence,
        platform: 'webapp',
        policy_lob: this.quotePayloadBeforePayment.policy_lob,
      }

    } else { }


    this.service.swalAlart.showLoading()
    this.service.manualQuery(payload)
      .toPromise()
      .then((response: any) => {
        //this.service.swalAlart.close()
        if (response.hasOwnProperty('responseCode') && response.responseCode == '000') {

          console.log("policy_lob===> " + payload.policy_lob);

          if (payload.policy_lob === "20") {
            localStorage.removeItem('quotePayload')

            this.service.swalAlart.fire({
              title: 'Payment successful',
              html: response.hasOwnProperty('stickerUrl') ? `SMS and Email sent with Policy details to print<br><br>Kindly print <a target='_blank' href='${response.stickerUrl}'>Sticker</a> and <a target='_blank' href='${response.certificateUrl}'>Certificate</a>` : `Payment completed successfully;your certificate has been mailed to you!<br><br/>Kindly click the <a target='_blank' href='${response.certificateUrl}'>Preview</a> link to view certificate`,
              icon: 'success',
              confirmButtonText: 'Done',
              showConfirmButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false
            })
              .then((result) => {
                if (result) {
                  this.router.navigate(['transactions']);
                  this.dialogRef.close()
                }

              });
          } else if (payload.policy_lob === "50") {
            localStorage.removeItem('quotePayload')

            this.service.swalAlart.fire({
              title: 'Payment successful',
              html: `SMS and email sent with policy details to print<br><br><a target='_blank' href='${response.certificateUrl}?print_form=0'>Click here to print <b>preprinted certificate</b></a><br><br><a target='_blank' href='${response.certificateUrl}?print_form=1'>Click here to print <b>normal certificate</b></a><br><br><a target='_blank' href='${response.travelDocUrl}'>Click here to print <b>travel documents</b></a>`,
              icon: 'success',
              confirmButtonText: 'Done',
              showConfirmButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false
            }).then((result) => {
              if (result) {
                this.router.navigate(['transactions']);
                this.dialogRef.close();
              }
            });

          } else {
            localStorage.removeItem('quotePayload')

            this.service.swalAlart.fire({
              title: 'Payment successful',
              html: `SMS and email sent with policy details to print<br><br><a target='_blank' href='${response.certificateUrl}?print_form=0'>Click here to print <b>preprinted certificate</b></a><br><br><a target='_blank' href='${response.certificateUrl}?print_form=1'>Click here to print <b>normal certificate</b></a>`,
              icon: 'success',
              confirmButtonText: 'Done',
              showConfirmButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false
            }).then((result) => {
              if (result) {
                this.router.navigate(['transactions']);
                this.dialogRef.close();

              }
            });

          }



        } else if (response.hasOwnProperty('responseCode') && response.responseCode == 'E55') {

          this.openfinalizeMomoRetryPaymentDialog(payload)
          this.dialogRef.close();


        } else if (response.hasOwnProperty('responseCode') && response.responseCode == '001') {
          localStorage.removeItem('quotePayload')

          this.service.swalAlart.close();
          this.service.swalAlart.fire({
            title: 'Processing Payment...',
            html: 'Please wait. An sms and email of policy and sticker details will be sent to you after processing payment.',
            icon: 'success',
            confirmButtonText: 'Done',
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false
          }).then((result) => {
            if (result) {
              this.router.navigate(['transactions']);
              this.dialogRef.close();
            }
          });


        } else if (response.hasOwnProperty('responseMessage') && response.responseCode == 'E31') {
          this.service.swalAlart.fire({
            title: 'Failed',
            text: 'Vehicle information already exist under a policy. Please check vehicle registration number and try again.',
            icon: 'error',
          });

        } else if (response.hasOwnProperty('responseMessage') && response.responseCode == 'E23') {
          this.service.swalAlart.fire({
            title: 'Failed',
            text: 'Invoice Already Paid',
            icon: 'error',
          });
        } else if (response.hasOwnProperty('responseMessage') && response.responseCode == 'E01') {
          this.service.swalAlart.fire({
            title: 'Failed',
            text: response.responseMessage,
            icon: 'error',
          });

        } else if (response.hasOwnProperty('responseMessage') && response.responseCode == 'E64') {
          this.service.swalAlart.fire({
            title: 'Failed',
            text: response.responseMessage,
            icon: 'error',
          });

        }

        else if (response.hasOwnProperty('responseCode') && response.responseCode == '500') {
          this.service.swalAlart.close()
          this.service.swalAlart.fire({
            title: 'Failed',
            text: 'Server error',
            icon: 'error',
          });
        }
        else {
          let errors = response.hasOwnProperty('responseMessage') && response.responseCode == '400 BAD_REQUEST' ? JSON.parse(response.responseMessage) : null;

          this.service.swalAlart.fire({
            title: 'Failed',
            text: errors && errors.errors.length > 0 ? `MID::${errors.errors[0]}` : 'Payment failed!',
            icon: 'error',
          });
        }
      })
  }


  openfinalizeMomoRetryPaymentDialog(payload) {
    const dialogRef = this.dialogRetryRef.open(FinalizeRetryMomoComponent, {
      disableClose: true,
      width: '350px',
      data: { quotePayload: payload }
    });
    dialogRef.afterClosed().subscribe((result: any) => {

      if (result.hasOwnProperty('data')) {
        result.data.quotePayload.module = this.service.currentUser().role.toLowerCase();
        //console.log('Data',result.data)
      }
    });

  }



}


